/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FindAllContactWithFilterIRoute } from "../api/Contacts";

export interface GetRateLimitsParamsIRoute {
  userUid: string;
}

export type ICustomFieldType = "TEXT" | "TIME" | "DATE" | "URL";

export interface ICustomField {
  id: string;
  name: string;
  categoryId: string;
  type: ICustomFieldType;
  createdAt: Date;
}

export interface PostRateLimitsBodyIRoute {
  userUid: string;
  rate: PartialIDailyLimitIdString;
}

export interface SetPirateUserIRoute {
  userUid: string;
  contactUserUid: string;
}

export interface ToggleUserDomainIRoute {
  adminUid: string;
  userUid: string;
}

export interface LoginIntoUserAccountBodyIRoute {
  email: string;
  userUid: string;
}

export interface GenerateTemporaryPasswordBodyIRoute {
  phone: string;
  captchaResponse: string;
}

export interface GenerateTemporaryPasswordResponseIRoute {
  status: string;
  data: { success: boolean };
}

export interface ValidateTemporaryPasswordBodyIRoute {
  phone: string;
  password: string;
}

export interface ValidateTemporararyPasswordResponseIRoute {
  status: string;
  data: { doesPasswordMatch: boolean };
}

export interface IAuthCheckPhoneParamsIRoute {
  phone: string;
}

export interface IAuthCheckPhoneResponseIRoute {
  status: string;
  data: { exists: true; type?: string };
}

export interface IAuthLoginBodyIRoute {
  phone: string;
  password: string;
}

export interface IAuthCreateBodyIRoute {
  phone: string;
  password: string;
  email: string;
  type: IUserAuthType;
  firstName: string;
  lastName: string;
  domain: string;
  alias: string;
  aliasName: string;
  userAppName: string;
  company: string;
  address: string;
}

export interface IAuthRenewTokenParamsIRoute {
  userUid: string;
}

export interface IAuthRenewTokenResponseIRoute {
  status: string;
  data: { token: string };
}

export interface IAuthLearnisticResetPasswordParamsIRoute {
  phone: string;
}

export interface IAuthLearnisticResetPasswordBodyIRoute {
  captchaResponse: string;
}

export interface IAuthLearnisticResetPasswordResponseIRoute {
  status: string;
  data: { ok: boolean };
}

export interface IAuthResetPasscodeBodyIRoute {
  type: "BERSERKER" | "INTERNAL" | "LEARNISTIC";
  phone: string;
  tempPassword: string;
  newPassword: string;
}

export interface IAuthResetPasscodeResponseIRoute {
  status: string;
  data:
    | { ok: true; userUid: string }
    | { ok: false }
    | ({ ok: true; userUid: string } & { ok: false });
}

export interface IAuthDoLoginLearnisticBodyIRoute {
  phone: string;
  password: string;
}

export interface IAuthDoLoginLearnisticResponseIRoute {
  status: string;
  data: { ok: boolean };
}

export interface IAuthLoginResponseIRoute {
  status: string;
  data: {
    login:
      | { error: false; userUid: string; msg?: string }
      | { error: true; msg: string; userUid?: string }
      | ({ error: false; userUid: string; msg?: string } & {
          error: true;
          msg: string;
          userUid?: string;
        });
    token: string;
  };
}

export interface UserEmailRestrictionsIRoute {
  emailsBlocked?: string[];
  espsBlocked?: string[];
  deviceIpsBlocked?: string[];
  deviceIdsBlocked?: string[];
  phoneNumbersBlocked?: string[];
  countryCodesBlocked?: string[];
  keywordsBlocked?: string[];
  keywordsFlagged?: string[];
  keywordsSuspended?: string[];
  countriesWhitelisted: string[];
  countryCodesWhitelisted: string[];
}

export interface IUserIRoute {
  _id: string;
  userUid: string;
  password: string;
  userAppName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  avatar: string;
  options: IUserOptions;
  apiKey?: string;
  emailOptions: IUserEmailOptions;
  leadSourceList?: string[];
  company: string;
  address: string;
  companyPhone?: string;
  customFields?: ICustomField[];
  adminUid?: string;
  domainIsVerified?: boolean;
  allowImport: boolean;
  enableBetaFeatures?: boolean;
  isActive: boolean;
  domain: { url: string; email: string };
  authType: IUserAuthType;
  emailRestrictions: IUserEmailRestrictions;
  lakeRestricted?: boolean;
  lrnProAccount?: boolean;
  liveTestingAccount?: boolean;
}

export interface UserCreateBodyIRoute {
  userUid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface FindOneInternalUserIRoute {
  userUid: string;
}

export interface GetInternalUserTokenIRoute {
  internalUserUid: string;
  userUid: string;
}

export interface FindOneUserIRoute {
  _id?: string;
  userUid?: string;
  userAppName?: string;
  adminUid?: string;
  email?: string;
  phone?: string;
  apiKey?: string;
}

export interface FindOneUserByUserUidIRoute {
  userUid: string;
}

export interface FindOneUserUserAppNameIRoute {
  userAppName: string;
}

export interface FindOneByUidIRoute {
  userUid: string;
}

export interface FindOneApiKeyIRoute {
  apiKey: string;
}

export interface PutUserIRoute {
  userUid: string;
  password: string;
  userAppName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  avatar: string;
  options: IUserOptions;
  apiKey?: string;
  emailOptions: IUserEmailOptions;
  company: string;
  address: string;
  companyPhone?: string;
  customFields?: string[];
  adminUid?: string;
  domainIsVerified?: boolean;
  allowImport: boolean;
  enableBetaFeatures?: boolean;
  isActive: boolean;
  domain: { url: string; email: string };
  authType: IUserAuthType;
  emailRestrictions: IUserEmailRestrictions;
  lakeRestricted?: boolean;
  lrnProAccount?: boolean;
  liveTestingAccount?: boolean;
}

export interface GetUserEmailOverviewIRoute {
  userUid: string;
}

export interface CreateAccountContactIRoute {
  email: string;
  firstName: string;
  lastName: string;
}

export interface CreateAccountUserIRoute {
  phone: string;
  captchaResponse: string;
}

export interface CheckEmailAccountIRoute {
  email: string;
}

export interface UserLoginBodyIRoute {
  phone: string;
  password: string;
  temporaryPassword: string;
}

export interface UserCheckPhoneBodyIRoute {
  phone: string;
}

export interface UserInfoParamsIRoute {
  uid: string;
}

export interface ICreateLearnisticIntegrationIRoute {
  userUid: string;
  phoneNumber: string;
  passcode: string;
}

export interface IGetLearnisticIntegrationIRoute {
  userUid: string;
}

export interface IUpdateLearnisticIntegrationIRoute {
  vAppIds: string[];
}

export interface ICreateEmailFromLearnisticBodyIRoute {
  isTemplate: boolean;
  userUid: string;
  records: IRecord[];
  subject: string;
  body: string;
  timeToRun: number;
  address: string;
  fromName: string;
  tagNames: string[];
  signatureData: {
    optionalSignature: string;
    additionalFooterText: string;
    textBeforeUnsubscribeLink: string;
    textAfterUnsubscribeLink: string;
    canSpam: string;
  };
}

export interface ICreateContactFromLearnisticBodyIRoute {
  userUid: string;
  records: IRecord[];
  shouldNotSendEmail?: boolean;
  customFields?: any;
}

export interface IDeleteContactFromLearnisticBodyIRoute {
  userUid: string;
  email: string;
}

export interface CreateCategoryIRoute {
  name: string;
  userUid: string;
  type: ICategoryType;
}

export interface FindAllCategoriesFromUserIRoute {
  userUid: string;
}

export interface FindOneCategoryFromUserIRoute {
  userUid: string;
  name: string;
}

export interface FindOneIRoute {
  _id?: string;
  name?: string;
  userUid?: string;
}

export interface UpdateCategoryIRoute {
  _id: string;
  name: string;
  type: ICategoryType;
}

export interface CreateTagIRoute {
  name: string;
  userUid: string;
  categoryId: string;
}

export interface FindOneTagFromUserIRoute {
  userUid: string;
  name: string;
  url?: string;
}

export interface FindRawTagFromUserIRoute {
  userUid: string;
  categoryId: string;
}

export interface FindAllTagsFromUserIRoute {
  userUid: string;
  categoryId?: string;
}

export interface UpdateTagIRoute {
  _id: string;
  name: string;
  categoryId: ObjectId | string;
}

export interface IActionIRoute {
  _id?: string;
  name: string;
  type: IActionTypes;
  stopTag?: IStopTag;
  manageTag?: IManageTag;
  email?: any;
  sms?: ISms;
  pushNotification?: IPushNotification;
  webHook?: IWebHook;
  setField?: ISetField;
  applyNote?: IApplyNote;
}

export type INodeIRoute = {
  _id?: ObjectId | string;
  name: string;
  type: INodeTypes;
  email?: IEmailAction;
  manageTag?: IManageTag;
  stopTag?: IStopTag;
  delayTimer?: IDelayTimer;
  dateTimer?: IDateTimer;
  sms?: ISms;
  pushNotification?: IPushNotification;
  webHook?: IWebHook;
  setField?: ISetField;
  applyNote?: IApplyNote;
  filter?: IFilter;
} & { _id?: string };

export interface CampaignIRoute {
  _id?: string;
  name: string;
  userUid: string;
  nodes: {
    _id?: ObjectId | string;
    name: string;
    type: INodeTypes;
    email?: IEmailAction;
    manageTag?: IManageTag;
    stopTag?: IStopTag;
    delayTimer?: IDelayTimer;
    dateTimer?: IDateTimer;
    sms?: ISms;
    pushNotification?: IPushNotification;
    webHook?: IWebHook;
    setField?: ISetField;
    applyNote?: IApplyNote;
    filter?: IFilter;
  }[];
  status: ICampaignStatus;
  tagConditions: ITagConditions[];
  stopTagConditions?: (ILearnisticApp | string)[];
  labels: string[];

  /** @format date-time */
  launchedAt?: string;

  /** @format date-time */
  createdAt: string;
  totalContacts: number;
  originalId?: string;
  previousId?: string;
  version: number;
  notes: string;

  /** @format date-time */
  lastNotesUpdate: string;
  campaignOptions: ICampaignOptions;
}

export interface EditCampaignIRoute {
  campaignId: string;
}

export interface CreateCampaignIRoute {
  name: string;
  userUid: string;
  labels: string[];
  nodes?: {
    _id?: ObjectId | string;
    name: string;
    type: INodeTypes;
    email?: IEmailAction;
    manageTag?: IManageTag;
    stopTag?: IStopTag;
    delayTimer?: IDelayTimer;
    dateTimer?: IDateTimer;
    sms?: ISms;
    pushNotification?: IPushNotification;
    webHook?: IWebHook;
    setField?: ISetField;
    applyNote?: IApplyNote;
    filter?: IFilter;
  }[];
  status?: ICampaignStatus;
  tagConditions?: ITagConditions[];
  stopTagConditions?: (ILearnisticApp | string)[];

  /** @format date-time */
  launchedAt?: string;
  originalId?: string;
  previousId?: string;
  notes: string;

  /** @format date-time */
  lastNotesUpdate: string;
  version: number;
  campaignOptions: ICampaignOptions;
}

export interface FindOneCampaignIRoute {
  campaignId: string;
}

export interface ToggleStatusCampaignIRoute {
  status: ICampaignStatus;
}

export interface FindAllCampaignIRoute {
  userUid: string;
}

export interface CheckCampaignNameIRoute {
  campaignName: string;
}

export interface FindAllCampaignQueryIRoute {
  limit?: number;
  offset?: number;
  orderByOrientation: -1 | 1;

  /** These are real strings */
  orderBy: string;
  labels?: string[] | string;
  status?: string[] | string;
  name?: string;
}

export interface PutCampaignIRoute {
  _id?: string;
  name: string;
  userUid: string;
  nodes: {
    _id?: ObjectId | string;
    name: string;
    type: INodeTypes;
    email?: IEmailAction;
    manageTag?: IManageTag;
    stopTag?: IStopTag;
    delayTimer?: IDelayTimer;
    dateTimer?: IDateTimer;
    sms?: ISms;
    pushNotification?: IPushNotification;
    webHook?: IWebHook;
    setField?: ISetField;
    applyNote?: IApplyNote;
    filter?: IFilter;
  }[];
  status: ICampaignStatus;
  tagConditions: ITagConditions[];
  stopTagConditions?: (ILearnisticApp | string)[];
  labels: string[];

  /** @format date-time */
  launchedAt?: string;

  /** @format date-time */
  createdAt: string;
  totalContacts: number;
  originalId?: string;
  previousId?: string;
  version: number;
  notes: string;

  /** @format date-time */
  lastNotesUpdate: string;
  campaignOptions: ICampaignOptions;
}

export interface EditCampaignDataIRoute {
  _id?: string;
  version: number;
  name: string;

  /** @format date-time */
  createdAt: string;
  nodes: {
    _id?: ObjectId | string;
    name: string;
    type: INodeTypes;
    email?: IEmailAction;
    manageTag?: IManageTag;
    stopTag?: IStopTag;
    delayTimer?: IDelayTimer;
    dateTimer?: IDateTimer;
    sms?: ISms;
    pushNotification?: IPushNotification;
    webHook?: IWebHook;
    setField?: ISetField;
    applyNote?: IApplyNote;
    filter?: IFilter;
  }[];
  status: ICampaignStatus;
  tagConditions: ITagConditions[];
  stopTagConditions?: (ILearnisticApp | string)[];
  labels: string[];

  /** @format date-time */
  launchedAt?: string;
  totalContacts: number;
  originalId?: string;
  previousId?: string;
  notes: string;

  /** @format date-time */
  lastNotesUpdate: string;
  campaignOptions: ICampaignOptions;
}

export interface LaunchCampaignIRoute {
  status: ICampaignStatus;
}

export interface FindOneLabelIRoute {
  labelId: string;
}

export interface FindAllLabelIRoute {
  userUid: string;
}

export interface CreateOrUpdateLabelIRoute {
  name: string;
  color: string;
  userUid: string;
  labelIndex: number;
}

export interface ErrorIRoute {
  status: "error";
  error: IError;
}

export interface ISetTestDriveContactIRoute {
  userUid: string;
  contactId: string;
}

export interface IContactIRoute {
  _id?: string;
  userUid: string;
  name: string;
  firstName?: string;
  lastName?: string;
  email: string;
  labels: string[];
  tags: IContactTag[];
  status: ContactStatus;
  customFields?: any;
  avatar?: string;
  phone?: string;
  deviceIds?: string[];

  /** @format date-time */
  createdAt: string;
  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
}

export interface DumpContactParamsIRoute {
  userUid: string;
}

export interface CreateContactIRoute {
  userUid: string;
  name: string;
  firstName?: string;
  lastName?: string;
  email: string;
  phone?: string;
  countryCode?: string;
  avatar?: string;
  status: ContactStatus;
  customFields?: any;
  tags?: string[];
  lastIp?: string;
  deviceIds?: string[];
  createdAt?: string | string;
  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
}

export interface CreateContactFormIRoute {
  formId: string;
  archiveName?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  password?: string;
  phone?: string;
  customFields?: any;
  note?: string;
  isFormBuilder?: boolean;
  username?: string;
}

export interface FindOneContactIRoute {
  contactId?: string;
  email?: string;
  userUid?: string;
}

export interface FindManyContactIRoute {
  contactIds?: string[];
  emails?: string[];
  userUid?: string;
  status?:
    | RegExp
    | {
        $eq?:
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            );
        $gt?:
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            );
        $gte?:
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            );
        $in?: (
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            )
        )[];
        $lt?:
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            );
        $lte?:
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            );
        $ne?:
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            );
        $nin?: (
          | RegExp
          | "ADMIN_UNSUBSCRIBED"
          | "BOT_FILLED"
          | "CONFIRMED"
          | "NOT_CONFIRMED"
          | "PENDING_CONFIRMATION"
          | "SPAM"
          | "SUPRESSED"
          | "SUSPENDED"
          | "UNSUBSCRIBED"
          | (
              | (RegExp & "ADMIN_UNSUBSCRIBED")
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
            )
        )[];
        $not?:
          | RegExp
          | QuerySelectorRegExp
          | QuerySelectorContactStatusNOTCONFIRMED
          | QuerySelectorContactStatusUNSUBSCRIBED
          | QuerySelectorContactStatusADMINUNSUBSCRIBED
          | QuerySelectorContactStatusSPAM
          | QuerySelectorContactStatusBOTFILLED
          | QuerySelectorContactStatusSUSPENDED
          | QuerySelectorContactStatusSUPPRESSED
          | QuerySelectorContactStatusPENDINGCONFIRMATION
          | QuerySelectorContactStatusCONFIRMED
          | (RegExp &
              QuerySelectorRegExp &
              QuerySelectorContactStatusNOTCONFIRMED &
              QuerySelectorContactStatusUNSUBSCRIBED &
              QuerySelectorContactStatusADMINUNSUBSCRIBED &
              QuerySelectorContactStatusSPAM &
              QuerySelectorContactStatusBOTFILLED &
              QuerySelectorContactStatusSUSPENDED &
              QuerySelectorContactStatusSUPPRESSED &
              QuerySelectorContactStatusPENDINGCONFIRMATION &
              QuerySelectorContactStatusCONFIRMED);
        $exists?: boolean;
        $type?:
          | BSONType
          | "array"
          | "binData"
          | "bool"
          | "date"
          | "dbPointer"
          | "decimal"
          | "double"
          | "int"
          | "javascript"
          | "javascriptWithScope"
          | "long"
          | "maxKey"
          | "minKey"
          | "null"
          | "number"
          | "object"
          | "objectId"
          | "regex"
          | "string"
          | "symbol"
          | "timestamp"
          | "undefined"
          | (
              | (BSONType & "array")
              | "binData"
              | "bool"
              | "date"
              | "dbPointer"
              | "decimal"
              | "double"
              | "int"
              | "javascript"
              | "javascriptWithScope"
              | "long"
              | "maxKey"
              | "minKey"
              | "null"
              | "number"
              | "object"
              | "objectId"
              | "regex"
              | "string"
              | "symbol"
              | "timestamp"
              | "undefined"
            );
        $expr?: any;
        $jsonSchema?: any;
        $regex?: RegExp | string;
        $options?: string;
        $geoIntersects?: { $geometry: Record<string, any> };
        $geoWithin?: Record<string, any>;
        $near?: Record<string, any>;
        $nearSphere?: Record<string, any>;
        $maxDistance?: number;
        $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
        $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
        $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
        $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
      }
    | "ADMIN_UNSUBSCRIBED"
    | "BOT_FILLED"
    | "CONFIRMED"
    | "NOT_CONFIRMED"
    | "PENDING_CONFIRMATION"
    | "SPAM"
    | "SUPRESSED"
    | "SUSPENDED"
    | "UNSUBSCRIBED"
    | (
        | (RegExp & {
            $eq?:
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                );
            $gt?:
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                );
            $gte?:
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                );
            $in?: (
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                )
            )[];
            $lt?:
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                );
            $lte?:
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                );
            $ne?:
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                );
            $nin?: (
              | RegExp
              | "ADMIN_UNSUBSCRIBED"
              | "BOT_FILLED"
              | "CONFIRMED"
              | "NOT_CONFIRMED"
              | "PENDING_CONFIRMATION"
              | "SPAM"
              | "SUPRESSED"
              | "SUSPENDED"
              | "UNSUBSCRIBED"
              | (
                  | (RegExp & "ADMIN_UNSUBSCRIBED")
                  | "BOT_FILLED"
                  | "CONFIRMED"
                  | "NOT_CONFIRMED"
                  | "PENDING_CONFIRMATION"
                  | "SPAM"
                  | "SUPRESSED"
                  | "SUSPENDED"
                  | "UNSUBSCRIBED"
                )
            )[];
            $not?:
              | RegExp
              | QuerySelectorRegExp
              | QuerySelectorContactStatusNOTCONFIRMED
              | QuerySelectorContactStatusUNSUBSCRIBED
              | QuerySelectorContactStatusADMINUNSUBSCRIBED
              | QuerySelectorContactStatusSPAM
              | QuerySelectorContactStatusBOTFILLED
              | QuerySelectorContactStatusSUSPENDED
              | QuerySelectorContactStatusSUPPRESSED
              | QuerySelectorContactStatusPENDINGCONFIRMATION
              | QuerySelectorContactStatusCONFIRMED
              | (RegExp &
                  QuerySelectorRegExp &
                  QuerySelectorContactStatusNOTCONFIRMED &
                  QuerySelectorContactStatusUNSUBSCRIBED &
                  QuerySelectorContactStatusADMINUNSUBSCRIBED &
                  QuerySelectorContactStatusSPAM &
                  QuerySelectorContactStatusBOTFILLED &
                  QuerySelectorContactStatusSUSPENDED &
                  QuerySelectorContactStatusSUPPRESSED &
                  QuerySelectorContactStatusPENDINGCONFIRMATION &
                  QuerySelectorContactStatusCONFIRMED);
            $exists?: boolean;
            $type?:
              | BSONType
              | "array"
              | "binData"
              | "bool"
              | "date"
              | "dbPointer"
              | "decimal"
              | "double"
              | "int"
              | "javascript"
              | "javascriptWithScope"
              | "long"
              | "maxKey"
              | "minKey"
              | "null"
              | "number"
              | "object"
              | "objectId"
              | "regex"
              | "string"
              | "symbol"
              | "timestamp"
              | "undefined"
              | (
                  | (BSONType & "array")
                  | "binData"
                  | "bool"
                  | "date"
                  | "dbPointer"
                  | "decimal"
                  | "double"
                  | "int"
                  | "javascript"
                  | "javascriptWithScope"
                  | "long"
                  | "maxKey"
                  | "minKey"
                  | "null"
                  | "number"
                  | "object"
                  | "objectId"
                  | "regex"
                  | "string"
                  | "symbol"
                  | "timestamp"
                  | "undefined"
                );
            $expr?: any;
            $jsonSchema?: any;
            $regex?: RegExp | string;
            $options?: string;
            $geoIntersects?: { $geometry: Record<string, any> };
            $geoWithin?: Record<string, any>;
            $near?: Record<string, any>;
            $nearSphere?: Record<string, any>;
            $maxDistance?: number;
            $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
            $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
            $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
            $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
          } & "ADMIN_UNSUBSCRIBED")
        | "BOT_FILLED"
        | "CONFIRMED"
        | "NOT_CONFIRMED"
        | "PENDING_CONFIRMATION"
        | "SPAM"
        | "SUPRESSED"
        | "SUSPENDED"
        | "UNSUBSCRIBED"
      );
  excludeStatus?: ContactStatus;
}

export interface FindOneContactByIdIRoute {
  contactId: string;
}

export interface FindAllContactIRoute {
  userUid: string;
  limit?: string;
  offset?: string;
  labels?: string[] | string;
  status?: string[] | string;
  tagQuery?: ITagQuery;
  email?: string;
  name?: string;
  phone?: string;
  statusOrder?: string;
  createdAt?: string;
  search?: string;
}

export interface PutContactIRoute {
  name?: string;
  email?: string;
  labels?: string[];
  tags?: IContactTag[];
  avatar?: string;
  customFields?: any;
}

export interface CountContactsIRoute {
  tagQueries: ITagQuery[];
}

export interface AddTagContactIRoute {
  tag: string;
}

export interface AddMultipleTagContactIRoute {
  tagsId: string[];
  contacts: string[];
}

export interface UpdateContactsFromImportIRoute {
  tagsId: string[];
  contacts: PartialIContactIRouteImportTagsStringArray[];
  isToUpdate: boolean;
}

export interface AddAndRemoveMultipleTagContactIRoute {
  addTagIds: string[];
  removeTagIds: string[];
  contacts?: string[];
  query?: FindAllContactIRoute;
}

export interface AddAndRemoveMultipleLabelsContactIRoute {
  addLabelIds: string[];
  removeLabelIds: string[];
  contacts?: string[];
  query?: FindAllContactWithFilterIRoute;
}

export interface DeleteManyContactIRoute {
  contactIds: string[];
  query?: FindAllContactIRoute;
  userUid: string;
}

export interface SendEmailConfirmationIRoute {
  contactIds?: string[];
  query?: FindAllContactIRoute;
}

export interface PostUnsubscribeContactsIRoute {
  userUid: string;
  contactIds?: string[];
  query?: FindAllContactIRoute;
}

export interface PostNotConfirmedContactsIRoute {
  userUid: string;
  contactIds?: string[];
  query?: FindAllContactIRoute;
}

export interface GetContactEmailsSentParamsIRoute {
  contactId: string;
}

export interface GetContactEmailsSentResponseIRoute {
  status: string;
  data: {
    _id: ObjectIdSerialized;
    subject: string;
    body: string;
    scheduleTo?: string;
    createdAt: string;
    type: string;
    status: IContactEmailStatus;
  }[];
}

export interface CheckUserCreatedContactsIRoute {
  contactIds: string[];
}

export interface IRunAutomationTriggersFromUserIRoute {
  userUid: string;
  types?: "UNSUBSCRIBE"[];
  contacts: IContact[];
}

export interface IFindAllAutomationTriggersFromUserIRoute {
  userUid: string;
}

export interface IFindAutomationTriggersFromUserIRoute {
  userUid: string;
  types?: "UNSUBSCRIBE"[];
}

export interface IFindOneByIdAutomationTriggersFromUserIRoute {
  _id: string;
}

export interface IAutomationTriggerUpdateIRoute {
  addedTags?: ITagWithoutExternalId[];
  removedTags?: ITagWithoutExternalId[];
  addedLearnisticTags?: ILearnisticApp[];
  removedLearnisticTags?: ILearnisticApp[];
  learnisticAppsToRemove?: string[];
}

export interface IAutomationTriggerCreateIRoute {
  userUid: string;
  type: "UNSUBSCRIBE";
  addedTags: ITagWithoutExternalId[];
  removedTags: ITagWithoutExternalId[];
  addedLearnisticTags: ILearnisticApp[];
  removedLearnisticTags: ILearnisticApp[];
  learnisticAppsToRemove: string[];
}

export interface GetBillingInfoIRoute {
  userUid: string;
}

export interface PrintInvoiceIRoute {
  invoiceId: string;
}

export interface AddSubscriptionUserIRoute {
  userUid: string;
  tier: number;
  admins: number;
  externalUsers: number;
}

export interface UpdateSubscriptionUserIRoute {
  userUid: string;
  newAdmins: number;
  newExternalUsers: number;
  newTier: number;
}

export interface UpsellIRoute {
  userUid: string;
  upsellUid: string;
}

export interface CreateStripeUserIRoute {
  name: string;
  userUid: string;
  billing_address: {
    street: string;
    state_region: string;
    city: string;
    country: string;
    zip_code: string;
  };
  shipping_address: {
    street: string;
    state_region: string;
    city: string;
    country: string;
    zip_code: string;
  };
  vatId?: string;
  companyName?: string;
}

export interface AddStripePaymentMethodIRoute {
  paymentMethodId: string;
}

export interface StartTestDriveUserIRoute {
  userUid: string;
}

export interface ConfirmActivationIRoute {
  userUid: string;
}

export interface ClickReferralIRoute {
  url: string;
}

export interface GetLairsIRoute {
  userUid: string;
}

export interface FindAllCampaignStepsFromContactIRoute {
  contactId: string;
}

export interface CreateCampaignStepIRoute {
  node: {
    _id?: ObjectId | string;
    name: string;
    type: INodeTypes;
    email?: IEmailAction;
    manageTag?: IManageTag;
    stopTag?: IStopTag;
    delayTimer?: IDelayTimer;
    dateTimer?: IDateTimer;
    sms?: ISms;
    pushNotification?: IPushNotification;
    webHook?: IWebHook;
    setField?: ISetField;
    applyNote?: IApplyNote;
    filter?: IFilter;
  };
  contactId: ObjectId | string;
  campaign: ICampaign;

  /** @format date-time */
  enteredAt: string;
  current: boolean;
}

export interface FindOneContactsBackupIRoute {
  _id?: string;
  key?: string;
}

export interface IEmailListIRoute {
  _id?: string;
  name: string;
  userUid: string;
  emails: string[];
}

export interface CreateEmailListIRoute {
  name: string;
  userUid: string;
  emails: string[];
}

export interface FindOneEmailListIRoute {
  listId: string;
}

export interface FindAllEmailListIRoute {
  userUid: string;
}

export interface PutEmailListIRoute {
  name: string;
  emails: string[];
}

export interface IPutEmailListIRoute {
  _id?: string;
  name: string;
  emails: string[];
}

export interface CreateExternalUserIRoute {
  name: string;
  mainUserUid: string;
}

export interface FindAllExternalUsersFromUserIRoute {
  mainUserUid: string;
}

export interface UpdateExternalUserIRoute {
  _id: string;
  name: string;
}

export interface CreateFormIRoute {
  name: string;
  userUid: string;
  nameType: FormNameType;
  tags: string[];
  submitted?: number;
  formTagId?: string;
  viewed?: number;
  url: string;
  isInternal?: boolean;
  externalUsers?: string[];
  description?: string;
  builder?: any;
  hasBuilder?: boolean;
  hasThankYouBuilder?: boolean;
  thankYouBuilder?: any;
}

export interface FindAllFormsFromUserIRoute {
  userUid: string;
}

export interface FindOneFormIRoute {
  formId: string;
}

export interface CloneFormBodyIRoute {
  formId: string;
  name: string;
}

export interface FindOneFormByNameIRoute {
  formName: string;
  appName: string;
}

export type UpdateFormIRoute = PartialCreateFormIRoute & { _id: string };

export interface GetHelpVideoParamsIRoute {
  videoContext: string;
}

export interface UpdateHelpVideoIRoute {
  _id: string;
  videoContext: string;
  videoUrl: string;
  enabled: boolean;
}

export interface UpdateAllHelpVideosIRoute {
  videos: IHelpVideo[];
}

export interface GetAllVideosResponseIRoute {
  status: string;
  data: IHelpVideo[];
}

export interface GetAllIntegrationsParamsIRoute {
  userUid: string;
}

export interface GetAllIntegrationsResponseIRoute {
  status: string;
  data: (
    | IThrivecartIntegration
    | ILearnisticIntegration
    | (IThrivecartIntegration & ILearnisticIntegration)
  )[];
}

export interface PostCreateIntegrationBodyIRoute {
  userUid: string;
  integration:
    | IThrivecartIntegration
    | ILearnisticIntegration
    | (IThrivecartIntegration & ILearnisticIntegration);
}

export interface PatchUpdateIntegrationBodyIRoute {
  userUid: string;
  integrationId: string;
  integration:
    | (ReadonlyPartialIThrivecartIntegration & Record<string, AssignableType>)
    | (ReadonlyPartialILearnisticIntegration & Record<string, AssignableType>)
    | ((ReadonlyPartialIThrivecartIntegration &
        Record<string, AssignableType>) &
        (ReadonlyPartialILearnisticIntegration &
          Record<string, AssignableType>));
}

export interface DeleteIntegrationParamsIRoute {
  integrationId: string;
}

export type FindAllLinksIRoute = (ITag & { url: string })[];

export interface CreateLinkIRoute {
  externalId: number;
  name: string;
  userUid: string;

  /** @format date-time */
  createdAt?: string;
  url: string;
}

export interface FindAllLinksFromUserIRoute {
  userUid: string;
}

export interface FindOneLinkIRoute {
  userUid: string;
  name?: string;
  url?: string;
}

export interface FindOneLinkParamsIRoute {
  linkId: string;
}

export interface UpdateLinkIRoute {
  _id?: ObjectId | string;
  externalId: number;
  name: string;
  userUid: string;

  /** @format date-time */
  createdAt?: string;
  url: string;
}

export interface CreateNoteCategoryIRoute {
  name: string;
  userUid: string;
  type: INoteType;
}

export interface FindAllNoteCategoriesFromUserIRoute {
  userUid: string;
}

export interface UpdateNoteCategoryIRoute {
  _id: string;
  name: string;
  type: INoteType;
}

export interface GetAllProductsByIntegrationParamsIRoute {
  userUid: string;
  type: IntegrationType;
}

export interface GetAllProductsByIntegrationResponseIRoute {
  status: string;
  data: IProduct[];
}

export interface PostCreateProductBodyIRoute {
  userUid: string;
  product: IProduct;
}

export interface PatchUpdateProductBodyIRoute {
  userUid: string;
  productId: string;
  product: PartialIProduct;
}

export interface DeleteProductParamsIRoute {
  productId: string;
}

export type CreateNoteIRoute = OmitINoteTextCategoryId & {
  categoryId?: string;
  text?: string;
};

export interface CreateScheduledCampaignIRoute {
  contactId: string;
  userUid: string;
  tagCondition: ITagConditions;
}

export interface LearnisticCampaignIRoute {
  contactPhone?: string;
  contactEmail?: string;
  tagIds: number[];
  learnisticVirtualApp: string;
}

export interface LearnisticStartCampaignIRoute {
  contactPhone?: string;
  contactEmail?: string;
  tagIds: number[];
  learnisticVirtualApp: string;
}

export interface LearnisticStopCampaignIRoute {
  contactPhone?: string;
  contactEmail?: string;
  tagIds: number[];
  learnisticVirtualApp: string;
}

export interface TryWebhookCampaignIRoute {
  webhook: IWebHook;
  email: string;
  userUid: string;
}

export interface ISearchIRoute {
  _id: string;
  userUid: string;
  name: string;
  search: ITagQuery;
  footerId: string;
  publicArchive: boolean;
  order?: number;
  labels?: string[];
}

export interface CreateSearchIRoute {
  name: string;
  userUid: string;
  search: ITagQuery;
  footerId: string;
  publicArchive: boolean;
  labels: string[];
}

export interface FindSearchIRoute {
  id: string;
}

export interface FindUserSearchIRoute {
  userUid: string;
}

export interface PutSearchIRoute {
  name: string;
  publicArchive: boolean;
  userUid: string;
  search?: ITagQuery;
  footerId?: string;
  labels?: string[];
}

export interface UpdateSearchOrderIRoute {
  newOrder: string[];
}

export interface ITrainingVideoCategoryIRoute {
  _id: ObjectIdSerialized;
  name: string;
}

export interface UpdateTrainingVideoCategoryIRoute {
  _id: ObjectIdSerialized;
  name: string;
}

export interface CreateTrainingVideoCategoryIRoute {
  name: string;
}

export interface GetTrainingVideoCategoryIRoute {
  id: string;
}

export interface ITrainingVideoIRoute {
  _id: ObjectIdSerialized;
  name: string;
  vimeoId: string;
  categoryId: string;
  enabled: boolean;

  /** @format date-time */
  createdAt: string;
  description: string;
  image: string;
}

export interface GetTrainingVideoIRoute {
  id: string;
}

export interface UpdateTrainingVideoIRoute {
  _id: string;
  name?: string;
  vimeoId?: string;
  categoryId?: string;
  enabled?: boolean;

  /** @format date-time */
  createdAt?: string;
  description?: string;
  image?: string;
}

export interface CreateTrainingVideoIRoute {
  image: string;
  enabled: boolean;
  name: string;
  categoryId: string;

  /** @format date-time */
  createdAt: string;
  description: string;
  vimeoId: string;
}

export interface IRoute {
  path: string;
  stack: any;
  all: IRouterHandlerIRoute;
  get: IRouterHandlerIRoute;
  post: IRouterHandlerIRoute;
  put: IRouterHandlerIRoute;
  delete: IRouterHandlerIRoute;
  patch: IRouterHandlerIRoute;
  options: IRouterHandlerIRoute;
  head: IRouterHandlerIRoute;
  checkout: IRouterHandlerIRoute;
  copy: IRouterHandlerIRoute;
  lock: IRouterHandlerIRoute;
  merge: IRouterHandlerIRoute;
  mkactivity: IRouterHandlerIRoute;
  mkcol: IRouterHandlerIRoute;
  move: IRouterHandlerIRoute;
  "m-search": IRouterHandlerIRoute;
  notify: IRouterHandlerIRoute;
  purge: IRouterHandlerIRoute;
  report: IRouterHandlerIRoute;
  search: IRouterHandlerIRoute;
  subscribe: IRouterHandlerIRoute;
  trace: IRouterHandlerIRoute;
  unlock: IRouterHandlerIRoute;
  unsubscribe: IRouterHandlerIRoute;
}

export interface EIRoute {
  path: string;
  stack: any;
  all: IRouterHandlerIRoute1;
  get: IRouterHandlerIRoute1;
  post: IRouterHandlerIRoute1;
  put: IRouterHandlerIRoute1;
  delete: IRouterHandlerIRoute1;
  patch: IRouterHandlerIRoute1;
  options: IRouterHandlerIRoute1;
  head: IRouterHandlerIRoute1;
  checkout: IRouterHandlerIRoute1;
  copy: IRouterHandlerIRoute1;
  lock: IRouterHandlerIRoute1;
  merge: IRouterHandlerIRoute1;
  mkactivity: IRouterHandlerIRoute1;
  mkcol: IRouterHandlerIRoute1;
  move: IRouterHandlerIRoute1;
  "m-search": IRouterHandlerIRoute1;
  notify: IRouterHandlerIRoute1;
  purge: IRouterHandlerIRoute1;
  report: IRouterHandlerIRoute1;
  search: IRouterHandlerIRoute1;
  subscribe: IRouterHandlerIRoute1;
  trace: IRouterHandlerIRoute1;
  unlock: IRouterHandlerIRoute1;
  unsubscribe: IRouterHandlerIRoute1;
}

export interface CalendarPropsIRoute {
  emailUid: string;
}

export interface DefaultCalendarPropsIRoute {
  summary: string;
  description: string;
  recurrence?: string;

  /** @format date-time */
  start: string;
  duration: number;
}

export interface IRedirectGoogleIRoute {
  code: string;
  state: string;
}

export interface GetThriveAccountInfoIRoute {
  apiKey: string;
}

export interface GetThriveAccountInfoResponseIRoute {
  status: string;
  data: IThriveAccountInfo;
}

export interface GetThriveAccountProductsIRoute {
  userUid: string;
}

export interface GetThriveAccountProductsResponseIRoute {
  status: string;
  data: IThrivecartProduct[];
}

export interface GetThriveAccountUpsellsIRoute {
  userUid: string;
}

export interface GetThriveAccountUpsellsResponseIRoute {
  status: string;
  data: IThrivecartUpsell[];
}

export interface GetThriveAccountBumpsIRoute {
  userUid: string;
}

export interface GetThriveAccountBumpsResponseIRoute {
  status: string;
  data: IThrivecartBump[];
}

export interface GetThriveAccountDownsellsIRoute {
  userUid: string;
}

export interface GetThriveAccountDownsellsResponseIRoute {
  status: string;
  data: IThrivecartDownsell[];
}

export interface IEmailIRoute {
  _id?: ObjectIdSerialized;
  userUid: string;
  body: string;
  subject: string;
  splitSubject?: string;
  splitMode?: "AGE" | "AGE_DOMAIN" | "DOMAIN";
  labels: string[];
  isFavorite: boolean;
  type: IEmailType;
  toList?: string[];
  tagQuery?: ITagQuery;

  /** @format date-time */
  scheduleTo?: string;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
  emailHash?: string;

  /** @format date-time */
  emailSortDate?: string;
  event?: DefaultCalendarPropsIRoute;
  footerId: string;
  aliasId: string;
  footer?: IFooter;
  alias?: IAlias;
  searchId?: string;
  contactsSentTo?: IContact[];
  contactsSentToIdsAndVersionHashes?: {
    contactId: ObjectIdSerialized;
    contactVersionHash: ObjectIdSerialized;
  }[];
  showOnArchive?: boolean;
  resendMetadata?: { type: "unclicks" | "unopens"; originalEmailHash: string };
  defaultModeColorLink?: string;
  darkModeColorLink?: string;
  font?: IFontType;
  interestingURLs?: Record<string, string[]>;
  isPersonal?: boolean;
}

export interface CreateEmailIRoute {
  body?: string;
  font?: IFontType;
  footer?: IFooter;
  _id?: ObjectIdSerialized;
  userUid: string;

  /** @format date-time */
  createdAt?: string;
  labels?: string[];
  type?: IEmailType;
  subject?: string;
  splitSubject?: string;
  splitMode?: "AGE" | "AGE_DOMAIN" | "DOMAIN";
  isFavorite?: boolean;
  toList?: string[];
  tagQuery?: ITagQuery;

  /** @format date-time */
  scheduleTo?: string;

  /** @format date-time */
  updatedAt?: string;

  /** @format date-time */
  emailSortDate?: string;
  event?: DefaultCalendarPropsIRoute;
  footerId?: string;
  aliasId?: string;
  alias?: IAlias;
  searchId?: string;
  contactsSentTo?: IContact[];
  contactsSentToIdsAndVersionHashes?: {
    contactId: ObjectIdSerialized;
    contactVersionHash: ObjectIdSerialized;
  }[];
  showOnArchive?: boolean;
  resendMetadata?: { type: "unclicks" | "unopens"; originalEmailHash: string };
  defaultModeColorLink?: string;
  darkModeColorLink?: string;
  interestingURLs?: Record<string, string[]>;
}

export type CreateDraftEmailIRoute = PartialIEmail & { userUid: string };

export type UpdateDraftEmailIRoute = PartialIDraftEmail;

export interface FindOneEmailIRoute {
  emailId: string;
}

export interface GetEmailSummaryParamsIRoute {
  emailHash: string;
}

export interface FindAllEmailIRoute {
  userUid: string;
  fromEmailSortDate?: string;
  limit?: string;
  filters?: {
    scheduled: boolean;
    sent: boolean;
    cancelled: boolean;
    labels: string[];
  };
  orderBy?: "MOST_RECENT" | "OLDEST";
  filterBy?: "ALL_TIME" | "NEXT_DAY" | "NEXT_MONTH" | "NEXT_WEEK";
}

export interface FindAllEmailCountParamsIRoute {
  userUid: string;
  fromEmailSortDate?: string;
  limit?: string;
  filters?: {
    scheduled: boolean;
    sent: boolean;
    cancelled: boolean;
    labels: string[];
  };
  orderBy?: "MOST_RECENT" | "OLDEST";
  filterBy?: "ALL_TIME" | "NEXT_DAY" | "NEXT_MONTH" | "NEXT_WEEK";
}

export interface FindAllEmailCountResponseIRoute {
  status: string;
  data: { count: number };
}

export interface PutEmailIRoute {
  _id?: ObjectIdSerialized;
  userUid: string;
  body: string;
  subject: string;
  splitSubject?: string;
  splitMode?: "AGE" | "AGE_DOMAIN" | "DOMAIN";
  labels: string[];
  isFavorite: boolean;
  type: IEmailType;
  toList?: string[];
  tagQuery?: ITagQuery;

  /** @format date-time */
  scheduleTo?: string;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
  emailHash?: string;

  /** @format date-time */
  emailSortDate?: string;
  event?: DefaultCalendarPropsIRoute;
  footerId: string;
  aliasId: string;
  footer?: IFooter;
  alias?: IAlias;
  searchId?: string;
  contactsSentTo?: IContact[];
  contactsSentToIdsAndVersionHashes?: {
    contactId: ObjectIdSerialized;
    contactVersionHash: ObjectIdSerialized;
  }[];
  showOnArchive?: boolean;
  resendMetadata?: { type: "unclicks" | "unopens"; originalEmailHash: string };
  defaultModeColorLink?: string;
  darkModeColorLink?: string;
  font?: IFontType;
  interestingURLs?: Record<string, string[]>;
}

export type UpdateEmailIRoute =
  | PartialIEmail1
  | PartialIDraftEmail
  | (PartialIEmail1 & PartialIDraftEmail);

export interface PostSetShowOnArchiveIRoute {
  emailId: string;
  showOnArchive: boolean;
}

export interface PostSimilarTimeIRoute {
  userUid: string;

  /** @format date-time */
  timestamp: string;
}

export interface PostSetShowOnArchiveResponseIRoute {
  status: string;
  data: any;
}

export interface ContactsCountBodyIRoute {
  tagQuery: ITagQuery;
  userUid: string;
}

export interface GetEmailSplitDetailsIRoute {
  status: string;
  data: {
    splitData: {
      split: { contacts: string[]; averageAge: number }[];
      firstContactCreatedAt: string;
    };
  };
}

export interface GetArchiveParamsIRoute {
  userUid: string;
}

export interface GetArchiveResponseIRoute {
  status: string;
  data: IArchive;
}

export interface PatchUpdateArchiveBodyIRoute {
  userUid: string;
  archive: PartialIArchive;
}

export interface PatchUpdateArchiveResponseIRoute {
  status: string;
  data: IArchive & { error?: string };
}

export interface GetEmailsFromArchiveNameParamsIRoute {
  archiveName: string;
}

export interface GetEmailsFromArchiveNameResponseIRoute {
  status: string;
  data: {
    title: string;
    emails: {
      _id: ObjectIdSerialized;
      subject: string;
      body: string;
      scheduleTo?: string;
      createdAt: string;
      alias: IAlias;
    }[];
    defaultModeColorLink: string;
    showOptInForm?: boolean;
  };
}

export interface GetEmailFromUserUidParamsIRoute {
  emailId: string;
}

export interface PostUpsertArchiveIRoute {
  userUid: string;
  archive?: IArchive;
}

export interface EndpointCreateContactIRoute {
  name: string;
  email: string;
  labels?: string[];
  tags?: string[];
  avatar?: string;
  status?: ContactStatus;
  lairName: string;
}

export interface EndpointFindOneContactIRoute {
  contactId?: string;
  email?: string;
}

export interface UnsubscribeContactQuerystringIRoute {
  emailHash?: string;
}

export interface EndpointAddTagContactIRoute {
  tag: string;
  lairName: string;
}

export interface ExternalApiTagsIRoute {
  status: "ok";
  data: {
    _id: string;
    name: string;
    categoryId: string;
    categoryName: string;
    createdAt: string;
  }[];
}

export interface ExternalApiTagIRoute {
  status: "ok";
  data: {
    _id: string;
    name: string;
    categoryId: string;
    categoryName: string;
    createdAt: string;
  };
}

export interface ExternalApiCategoriesIRoute {
  status: "ok";
  data: { _id: string; name: string; type: string }[];
}

export interface ExternalApiSuccessIRoute {
  status: "ok";
  data: { success: boolean };
}

export interface ExternalApiTagQuerystringIRoute {
  categoryId: string;
}

export interface ExternalApiTagParamsIRoute {
  tagId: string;
}

export interface ExternalApiCreateTagIRoute {
  categoryId: string;
  name: string;
}

export interface ExternalApiContactParamsIRoute {
  offset: string;
  tagId?: string;
}

export interface ExternalApiContactIRoute {
  status: "ok";
  data: {
    _id: string;
    email: string;
    firstName: string;
    lastName: string;
    tags: TagsFromContact[];
    phone: string;
    status: string;
    billingStreet1?: string;
    billingStreet2?: string;
    billingCity?: string;
    billingCountry?: string;
    billingState?: string;
    billingPostalCode?: string;
    billingPhoneCountryCode?: string;
    billingPhone?: string;
    shippingStreet1?: string;
    shippingStreet2?: string;
    shippingCity?: string;
    shippingCountry?: string;
    shippingState?: string;
    shippingPostalCode?: string;
    shippingPhoneCountryCode?: string;
    shippingPhone?: string;
  };
}

export interface ExternalApiContactArrayIRoute {
  status: "ok";
  data: {
    _id: string;
    email: string;
    firstName: string;
    lastName: string;
    tags: TagsFromContact[];
    phone: string;
    status: string;
    billingStreet1?: string;
    billingStreet2?: string;
    billingCity?: string;
    billingCountry?: string;
    billingState?: string;
    billingPostalCode?: string;
    billingPhoneCountryCode?: string;
    billingPhone?: string;
    shippingStreet1?: string;
    shippingStreet2?: string;
    shippingCity?: string;
    shippingCountry?: string;
    shippingState?: string;
    shippingPostalCode?: string;
    shippingPhoneCountryCode?: string;
    shippingPhone?: string;
  }[];
}

export interface ExternalApiUserInfoIRoute {
  status: "ok";
  data: { email: string; firstName: string; lastName: string; userUid: string };
}

export interface ExternalApiCreateContactBodyIRoute {
  firstName?: string;
  lastName?: string;
  email: string;
  phone?: string;
  tags?: string[];
  status?: ContactStatus;
  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
  customFields?: any;
  shouldOverwrite?: boolean;
}

export interface ExternalApiApplyTagBodyIRoute {
  email: string;
  tagId: string;
}

export interface ExternalApiApplyOrRemoveTagsBodyIRoute {
  email: string;
  addTagIds: string[];
  removeTagIds: string[];
}

/**
 * This Example interface can be anywhere in your project
 */
export interface CreateConversationIRoute {
  fullname: string;
  question: string;
  email: string;
}

/**
 * A class representation of the BSON ObjectId type.
 */
export interface ObjectId {
  /** The generation time of this ObjectId instance */
  generationTime: number;
}

export enum IUserAuthType {
  BERSERKER = "BERSERKER",
  INTERNAL = "INTERNAL",
  LEARNISTIC = "LEARNISTIC",
}

export interface IUserOptions {
  twoStepVerifiation: boolean;
  protectedTags: string[];
  desktopNotifications: boolean;
  receiveNewFeatures: boolean;
  firstLineAsSubject: boolean;
  extraCarriage: boolean;
  doNotWarnFirstLine: boolean;
  doNotWarnExtraCarriage: boolean;
  doNotShowGettingStarted: boolean;
  sendEmailConfirmation: boolean;
  emailConfirmationLink?: string;
  showPreviewLink: boolean;
  interestTagging: boolean;
  doNotWarnInterestTagging: boolean;
  customCopy?: IVirtualField;
  countriesList: "BLACKLIST" | "WHITELIST";
  countryCodesList: "BLACKLIST" | "WHITELIST";
  scheduleInterval: IScheduleIntervalOptions;
  startPage: IStartPageOptions;
  favoriteScheduleTimes: string[];
  enableFavoriteTimes: boolean;
  doNotShowFavoriteTimesAdvice: boolean;
  autoListOptions: {
    frequencyDays: number;
    time: string;
    lastAutoList: string;
    nextAutoList: string;
  };
  statsEmail: {
    time: string;
    receiveWeekEmail: boolean;
    lastWeekEmail: string;
    nextWeekEmail: string;
    receiveDailyEmail: boolean;
    lastDailyEmail: string;
    nextDailyEmail: string;
  };
  testEmailRecipient?: string[];
}

export interface IVirtualField {
  key: string;
  template: string;
  fields: string[];
  bypass?: boolean;
}

export enum IScheduleIntervalOptions {
  FIFTEEN_MINUTES = "FIFTEEN_MINUTES",
  FIVE_MINUTES = "FIVE_MINUTES",
}

export enum IStartPageOptions {
  ALL_EMAILS = "ALL_EMAILS",
  DASHBOARD = "DASHBOARD",
  SEND_BROADCAST = "SEND_BROADCAST",
}

export interface IUserEmailOptions {
  aliases: IAlias[];
  footers: IFooter[];
  font: { size: number; family: string };
  defaultModeColorLink: string;
  darkModeColorLink: string;
  theme: ITheme;
  showOnArchive?: boolean;
  splitTesting?: boolean;
  delayed: string;
  automaticallyTimeZone: boolean;
  timeZone: string;
  maxWidth?: number;
  unlimitedLinks?: boolean;
  autoBoldLinks?: boolean;
}

export interface IAlias {
  id: string;
  fromName: string;
  address: string;
}

export interface IFooter {
  id: string;
  name: string;
  signature: string;
  additionalFooterText: string;
  textBeforeUnsubscribe: string;
  textAfterUnsubscribe: string;
  hasSeparatorLine: "BEFORE_CAN" | "BEFORE_FOOTER";
}

export interface ITheme {
  border: string;
  color: string;
  textColor: string;
  placeholderColor: string;
  titleColor: string;
  titlePlaceholderColor: string;
}

export interface IUserEmailRestrictions {
  emailsBlocked: string[];
  espsBlocked: string[];
  deviceIpsBlocked: string[];
  deviceIdsBlocked: string[];
  phoneNumbersBlocked: string[];
  countryCodesBlocked: string[];
  keywordsBlocked: string[];
  keywordsFlagged: string[];
  keywordsSuspended: string[];
  partialKeywordsBlocked?: IPartialKeyword[];
  partialKeywordsFlagged?: IPartialKeyword[];
  partialKeywordsSuspended?: IPartialKeyword[];
  countriesBlocked: string[];
  countriesWhitelisted: string[];
  countryCodesWhitelisted: string[];
}

export interface IPartialKeyword {
  keyword: string;
  type: "CONTAINS" | "ENDS_WITH" | "STARTS_WITH";
}

export interface IRecord {
  recipient: string;
  tracking_id: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export enum ICategoryType {
  System = "system",
  User = "user",
}

export enum IActionTypes {
  ApplyNote = "applyNote",
  ApplyTag = "applyTag",
  Email = "email",
  Filter = "filter",
  PushNotification = "pushNotification",
  SetField = "setField",
  Sms = "sms",
  WebHook = "webHook",
}

export interface IStopTag {
  tags: ITagWithoutExternalId[];
  learnisticTag?: ILearnisticApp;
}

export interface ITagWithoutExternalId {
  _id?: ObjectId | string;
  name: string;
  userUid: string;
  categoryId: ObjectId | string;

  /** @format date-time */
  createdAt?: string;
}

export interface ILearnisticApp {
  description: string;
  vAppId: string;
  userRole: number;
  tags: ILearnisticTag[];
}

export interface ILearnisticTag {
  id: number;
  name: string;
  active: boolean;
  category: string;
}

export interface IManageTag {
  addedTags: ITagWithoutExternalId[];
  removedTags: ITagWithoutExternalId[];
  addedLearnisticTags: ILearnisticApp[];
  removedLearnisticTags: ILearnisticApp[];
}

export interface ISms {
  message: string;
}

export interface IPushNotification {
  title: string;
  content: string;
}

export interface IWebHook {
  url: string;
  contentType: "form-data" | "json";
  authorization?: string;
  fields: { name: string; value: string }[];
}

export interface ISetField {
  field: string;
  newValue: string;
}

export interface IApplyNote {
  title: string;
  description?: string;

  /** @format date-time */
  timestamp: string;
}

export enum INodeTypes {
  ApplyNote = "applyNote",
  DateTimer = "dateTimer",
  DelayTimer = "delayTimer",
  Email = "email",
  Filter = "filter",
  ManageTag = "manageTag",
  PushNotification = "pushNotification",
  SetField = "setField",
  Sms = "sms",
  StopTag = "stopTag",
  WebHook = "webHook",
}

export interface IEmailAction {
  subject: string;
  body: string;
  footerId: string;
  aliasId: string;
  interestingURLs?: Record<string, string[]>;
}

export interface IDelayTimer {
  delay: number;
  unit: number;
  constraints?: IDelayTimerConstraints;
}

export interface IDelayTimerConstraints {
  weekDays: number[];

  /** @format date-time */
  time: string;
}

export interface IDateTimer {
  /** @format date-time */
  date: string;
}

export interface IFilter {
  tagQuery: NamedTagQuery;
}

export interface NamedTagQuery {
  operator: "ANY_OF" | "NONE_OF";
  tags: { id: string; name: string }[];
  next?: { type: "AND" | "OR"; query: NamedTagQuery };
}

export enum ICampaignStatus {
  Active = "Active",
  Archive = "Archive",
  Draft = "Draft",
  Inactive = "Inactive",
}

export interface ITagConditions {
  tagId: string;
  action: "add" | "remove";
  learnisticTag?: ILearnisticApp;
}

export interface ICampaignOptions {
  defaultFooterId: string;
  defaultAliasId: string;
  fixedDateStrategy: IFixedDateStrategy;
  fixed?: boolean;
  preventReentering?: boolean;
}

export enum IFixedDateStrategy {
  Block = "Block",
  Jump = "Jump",
}

export interface IError {
  code: string;
  message: string;
}

export interface IContactTag {
  _id: string;

  /** @format date-time */
  appliedAt?: string;
}

export enum ContactStatus {
  ADMIN_UNSUBSCRIBED = "ADMIN_UNSUBSCRIBED",
  BOT_FILLED = "BOT_FILLED",
  CONFIRMED = "CONFIRMED",
  NOT_CONFIRMED = "NOT_CONFIRMED",
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  SPAM = "SPAM",
  SUPRESSED = "SUPRESSED",
  SUSPENDED = "SUSPENDED",
  UNSUBSCRIBED = "UNSUBSCRIBED",
}

export interface RegExp {
  source: string;
  global: boolean;
  ignoreCase: boolean;
  multiline: boolean;
  lastIndex: number;
  flags: string;
  sticky: boolean;
  unicode: boolean;
  dotAll: boolean;
}

export type BSONType = -1 | 1 | 127;

/**
 * A class representation of the BSON Binary type.
 */
export interface Binary {
  /** The underlying Buffer which stores the binary data. */
  buffer: number[];

  /** Binary data subtype */
  sub_type?: number;
}

export interface ITagQuery {
  operator: "ALL" | "ALL_OF" | "ANY_OF" | "NONE_OF";
  tags: string[];
  next?: { type: "AND" | "OR"; query: ITagQuery };
}

export type ObjectIdSerialized = string;

export enum IContactEmailStatus {
  CLICKED = "CLICKED",
  OPENED = "OPENED",
  REPORTED = "REPORTED",
  UNOPENED = "UNOPENED",
}

export interface IContact {
  _id?: ObjectId | string;
  userUid: string;
  name: string;
  email: string;
  labels: string[];
  tags: IContactTag[];
  avatar?: string;
  phone?: string;

  /** @format date-time */
  createdAt: string;
  customFields?: any;
  status?: ContactStatus;
  salutation?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
  contactVersionHash: ObjectIdSerialized;
}

export interface ICampaign {
  _id?: ObjectId | string;
  name: string;
  userUid: string;
  nodes: {
    _id?: ObjectId | string;
    name: string;
    type: INodeTypes;
    email?: IEmailAction;
    manageTag?: IManageTag;
    stopTag?: IStopTag;
    delayTimer?: IDelayTimer;
    dateTimer?: IDateTimer;
    sms?: ISms;
    pushNotification?: IPushNotification;
    webHook?: IWebHook;
    setField?: ISetField;
    applyNote?: IApplyNote;
    filter?: IFilter;
  }[];
  status: ICampaignStatus;
  tagConditions: ITagConditions[];
  stopTagConditions?: (ILearnisticApp | string)[];
  labels: string[];

  /** @format date-time */
  launchedAt?: string;

  /** @format date-time */
  createdAt: string;
  totalContacts: number;
  originalId?: string;
  previousId?: string;
  version: number;
  notes: string;

  /** @format date-time */
  lastNotesUpdate: string;
  campaignOptions: ICampaignOptions;
}

export enum FormNameType {
  FIRST_NAME = "FIRST_NAME",
  FULL_NAME = "FULL_NAME",
  NO_NAME = "NO_NAME",
}

export interface IHelpVideo {
  _id: ObjectIdSerialized;
  videoContext: string;
  videoUrl: string;
  enabled: boolean;
}

export interface IThrivecartIntegration {
  _id?: ObjectIdSerialized;
  type: "THRIVECART";
  userUid: string;
  args: { apiKey: string; accountName: string };
}

export interface ILearnisticIntegration {
  _id?: ObjectIdSerialized;
  type: "LEARNISTIC";
  userUid: string;
  args: { learnisticId: string; vAppIds: string[]; maxIntegrations: number };
}

export interface IStripeIntegration {
  _id?: ObjectIdSerialized;
  type: "STRIPE";
  userUid: string;

  args: {
    apiKey: string;
    integrationId: string;
  };
}

export type AssignableType = object;

export interface ITag {
  _id?: ObjectId | string;
  externalId: number;
  name: string;
  userUid: string;
  categoryId: ObjectId | string;

  /** @format date-time */
  createdAt?: string;
}

export enum INoteType {
  SYSTEM = "SYSTEM",
  USER = "USER",
}

export type IntegrationType = any;

export enum ProductType {
  THRIVECART = "THRIVECART",
  STRIPE = "STRIPE",
}

interface IGenericProduct {
  _id?: ObjectIdSerialized;

  productId: string;
  productName: string;

  type: ProductType;

  userUid: string;
  tagIds: string[];
}

export interface ThrivecartProduct extends IGenericProduct {
  // To identify from the webhook coming from the service
  // what is the owner of this product
  productTypeId: string;

  type: ProductType.THRIVECART;
}

export interface StripeProduct extends IGenericProduct {
  type: ProductType.STRIPE;
}

export type IProduct = ThrivecartProduct | StripeProduct;

export interface IForm {
  /** A class representation of the BSON ObjectId type. */
  _id: ObjectId;
  name: string;
  nameType: FormNameType;
  tags: string[];
  userUid: string;
  submitted?: number;
  formTagId?: string;
  viewed?: number;
  url: string;

  /** @format date-time */
  createdAt: string;
  isInternal?: boolean;
  externalUsers?: string[];
  description?: string;
  builder?: any;
  hasBuilder?: boolean;
  hasThankYouBuilder?: boolean;
  thankYouBuilder?: any;
}

export interface IExternalUser {
  /** A class representation of the BSON ObjectId type. */
  _id: ObjectId;
  mainUserUid: string;
  name: string;
  password: string;
}

export interface IDeviceInfo {
  ip: string;
  deviceId: string;
  browser: string;
  device: string;
  os: string;
}

export interface IThriveAccountInfo {
  account_name: string;
  account_id: string;
  account_version: string;
  account_url: string;
  user_id: string;
  user_username: string;
  user_name: string;
  custom_domain_enabled: boolean;
  custom_domain?: any;
}

export interface IThrivecartProduct {
  product_id: string;
  name: string;
  label?: string;
  url?: string;
  embed_type?: string;
  status?: string;
  statusString?: string;
  type?: string;
  typeString?: string;
}

export interface IThrivecartUpsell {
  upsell_id: string;
  name: string;
  label?: string;
  url?: string;
  embed_type?: string;
  status?: string;
  statusString?: string;
  type?: string;
  typeString?: string;
}

export interface IThrivecartBump {
  bump_id: string;
  name: string;
  label?: string;
  url?: string;
  embed_type?: string;
  status?: string;
  statusString?: string;
  type?: string;
  typeString?: string;
}

export interface IThrivecartDownsell {
  downsell_id: string;
  name: string;
  label?: string;
  type?: string;
  typeString?: string;
}

export enum IEmailType {
  Backup = "backup",
  Campaign = "campaign",
  Cancelled = "cancelled",
  Confirmation = "confirmation",
  Draft = "draft",
  Dump = "dump",
  Report = "report",
  Schedule = "schedule",
  Sent = "sent",
  Stats = "stats",
  Test = "test",
}

export enum IFontType {
  Arial = "Arial",
  CourierNew = "Courier New",
  SansSerif = "Sans Serif",
}

export interface IArchive {
  _id?: ObjectIdSerialized;
  title: string;
  showOptInForm: boolean;
  userUid: string;
  enabled: boolean;
  period: 10 | 180 | 30 | 365 | 60 | 90 | 9999;
}

export interface TagsFromContact {
  _id: string;
  appliedAt: string;
}

export interface PartialIDailyLimitIdString {
  /** A class representation of the BSON ObjectId type. */
  _id?: ObjectId;
  userUid?: string;
  dailyLimit?: number;
  currentDaily?: number;

  /** @format date-time */
  lastUpdate?: string;
}

export interface QuerySelectorRegExp {
  $eq?: RegExp;
  $gt?: RegExp;
  $gte?: RegExp;
  $in?: RegExp[];
  $lt?: RegExp;
  $lte?: RegExp;
  $ne?: RegExp;
  $nin?: RegExp[];
  $not?: QuerySelectorRegExp;

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusNOTCONFIRMED {
  $eq?: "NOT_CONFIRMED";
  $gt?: "NOT_CONFIRMED";
  $gte?: "NOT_CONFIRMED";
  $in?: "NOT_CONFIRMED"[];
  $lt?: "NOT_CONFIRMED";
  $lte?: "NOT_CONFIRMED";
  $ne?: "NOT_CONFIRMED";
  $nin?: "NOT_CONFIRMED"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusNOTCONFIRMED
    | (RegExp & QuerySelectorContactStatusNOTCONFIRMED);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusUNSUBSCRIBED {
  $eq?: "UNSUBSCRIBED";
  $gt?: "UNSUBSCRIBED";
  $gte?: "UNSUBSCRIBED";
  $in?: "UNSUBSCRIBED"[];
  $lt?: "UNSUBSCRIBED";
  $lte?: "UNSUBSCRIBED";
  $ne?: "UNSUBSCRIBED";
  $nin?: "UNSUBSCRIBED"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusUNSUBSCRIBED
    | (RegExp & QuerySelectorContactStatusUNSUBSCRIBED);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusADMINUNSUBSCRIBED {
  $eq?: "ADMIN_UNSUBSCRIBED";
  $gt?: "ADMIN_UNSUBSCRIBED";
  $gte?: "ADMIN_UNSUBSCRIBED";
  $in?: "ADMIN_UNSUBSCRIBED"[];
  $lt?: "ADMIN_UNSUBSCRIBED";
  $lte?: "ADMIN_UNSUBSCRIBED";
  $ne?: "ADMIN_UNSUBSCRIBED";
  $nin?: "ADMIN_UNSUBSCRIBED"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusADMINUNSUBSCRIBED
    | (RegExp & QuerySelectorContactStatusADMINUNSUBSCRIBED);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusSPAM {
  $eq?: "SPAM";
  $gt?: "SPAM";
  $gte?: "SPAM";
  $in?: "SPAM"[];
  $lt?: "SPAM";
  $lte?: "SPAM";
  $ne?: "SPAM";
  $nin?: "SPAM"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusSPAM
    | (RegExp & QuerySelectorContactStatusSPAM);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusBOTFILLED {
  $eq?: "BOT_FILLED";
  $gt?: "BOT_FILLED";
  $gte?: "BOT_FILLED";
  $in?: "BOT_FILLED"[];
  $lt?: "BOT_FILLED";
  $lte?: "BOT_FILLED";
  $ne?: "BOT_FILLED";
  $nin?: "BOT_FILLED"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusBOTFILLED
    | (RegExp & QuerySelectorContactStatusBOTFILLED);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusSUSPENDED {
  $eq?: "SUSPENDED";
  $gt?: "SUSPENDED";
  $gte?: "SUSPENDED";
  $in?: "SUSPENDED"[];
  $lt?: "SUSPENDED";
  $lte?: "SUSPENDED";
  $ne?: "SUSPENDED";
  $nin?: "SUSPENDED"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusSUSPENDED
    | (RegExp & QuerySelectorContactStatusSUSPENDED);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusSUPPRESSED {
  $eq?: "SUPRESSED";
  $gt?: "SUPRESSED";
  $gte?: "SUPRESSED";
  $in?: "SUPRESSED"[];
  $lt?: "SUPRESSED";
  $lte?: "SUPRESSED";
  $ne?: "SUPRESSED";
  $nin?: "SUPRESSED"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusSUPPRESSED
    | (RegExp & QuerySelectorContactStatusSUPPRESSED);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusPENDINGCONFIRMATION {
  $eq?: "PENDING_CONFIRMATION";
  $gt?: "PENDING_CONFIRMATION";
  $gte?: "PENDING_CONFIRMATION";
  $in?: "PENDING_CONFIRMATION"[];
  $lt?: "PENDING_CONFIRMATION";
  $lte?: "PENDING_CONFIRMATION";
  $ne?: "PENDING_CONFIRMATION";
  $nin?: "PENDING_CONFIRMATION"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusPENDINGCONFIRMATION
    | (RegExp & QuerySelectorContactStatusPENDINGCONFIRMATION);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface QuerySelectorContactStatusCONFIRMED {
  $eq?: "CONFIRMED";
  $gt?: "CONFIRMED";
  $gte?: "CONFIRMED";
  $in?: "CONFIRMED"[];
  $lt?: "CONFIRMED";
  $lte?: "CONFIRMED";
  $ne?: "CONFIRMED";
  $nin?: "CONFIRMED"[];
  $not?:
    | RegExp
    | QuerySelectorContactStatusCONFIRMED
    | (RegExp & QuerySelectorContactStatusCONFIRMED);

  /**
   * When `true`, `$exists` matches the documents that contain the field,
   * including documents where the field value is null.
   */
  $exists?: boolean;
  $type?:
    | BSONType
    | "array"
    | "binData"
    | "bool"
    | "date"
    | "dbPointer"
    | "decimal"
    | "double"
    | "int"
    | "javascript"
    | "javascriptWithScope"
    | "long"
    | "maxKey"
    | "minKey"
    | "null"
    | "number"
    | "object"
    | "objectId"
    | "regex"
    | "string"
    | "symbol"
    | "timestamp"
    | "undefined"
    | (
        | (BSONType & "array")
        | "binData"
        | "bool"
        | "date"
        | "dbPointer"
        | "decimal"
        | "double"
        | "int"
        | "javascript"
        | "javascriptWithScope"
        | "long"
        | "maxKey"
        | "minKey"
        | "null"
        | "number"
        | "object"
        | "objectId"
        | "regex"
        | "string"
        | "symbol"
        | "timestamp"
        | "undefined"
      );
  $expr?: any;
  $jsonSchema?: any;
  $regex?: RegExp | string;
  $options?: string;
  $geoIntersects?: { $geometry: Record<string, any> };
  $geoWithin?: Record<string, any>;
  $near?: Record<string, any>;
  $nearSphere?: Record<string, any>;
  $maxDistance?: number;
  $bitsAllClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAllSet?: number[] | Binary | number | (number[] & Binary);
  $bitsAnyClear?: number[] | Binary | number | (number[] & Binary);
  $bitsAnySet?: number[] | Binary | number | (number[] & Binary);
}

export interface PartialIContactIRouteImportTagsStringArray {
  _id?: string;
  userUid?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  labels?: string[];
  tags?: IContactTag[];
  status?: ContactStatus;
  customFields?: any;
  avatar?: string;
  phone?: string;
  deviceIds?: string[];

  /** @format date-time */
  createdAt?: string;
  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
  importTags?: string[];
}

export interface PartialCreateFormIRoute {
  name?: string;
  userUid?: string;
  nameType?: FormNameType;
  tags?: string[];
  submitted?: number;
  formTagId?: string;
  viewed?: number;
  url?: string;
  isInternal?: boolean;
  externalUsers?: string[];
  description?: string;
  builder?: any;
  hasBuilder?: boolean;
  hasThankYouBuilder?: boolean;
  thankYouBuilder?: any;
}

export interface ReadonlyPartialIThrivecartIntegration {
  _id?: ObjectIdSerialized;
  type?: "THRIVECART";
  userUid?: string;
  args?: { apiKey: string; accountName: string };
}

export interface ReadonlyPartialILearnisticIntegration {
  _id?: ObjectIdSerialized;
  type?: "LEARNISTIC";
  userUid?: string;
  args?: { learnisticId: string; vAppIds: string[]; maxIntegrations: number };
}

export interface PartialIProduct {
  _id?: ObjectIdSerialized;
  productId?: string;
  productName?: string;
  type?: "THRIVECART";
  productTypeId?: string;
  userUid?: string;
  tagIds?: string[];
}

export interface OmitINoteTextCategoryId {
  /** A class representation of the BSON ObjectId type. */
  _id?: ObjectId;
  userUid: string;

  /** @format date-time */
  createdAt: string;
  trigger: INoteTriggerCONTACTCREATED;
  params:
    | { tag: ITag; contact: IContact; from: "CONTACT_SCREEN" | "IMPORT_CSV" }
    | { tag: ITag; contact: IContact; from: "FORM"; form: IForm }
    | { tag: ITag; contact: IContact; from: "FORM"; form: IForm }
    | { tag: ITag; contact: IContact; from: "CAMPAIGN"; campaign: ICampaign }
    | { tag: ITag; contact: IContact; from: "SOCIALLAIR"; lair: string }
    | { tag: ITag; contact: IContact; from: "LEARNISTIC" }
    | {
        form: IForm;
        contact: IContact;
        from: "FORM";
        externalUser: IExternalUser;
        description: string;
      }
    | { contact: IContact; from: "CONTACT_SCREEN" }
    | { contact: IContact; from: "EXTERNAL_API" }
    | { contact: IContact; from: "CONTACT_SCREEN"; status: ContactStatus }
    | {
        from: "CONTACT_SCREEN" | "EXTERNAL_API" | "IMPORT_CSV" | "LEARNISTIC";
        contact: IContact;
      }
    | { from: "FORM"; contact: IContact; form: IForm }
    | { from: "SOCIALLAIR"; contact: IContact; lair: string }
    | { from: "THRIVECART_WEBHOOK"; contact: IContact; product: IProduct }
    | ({
        tag: ITag;
        contact: IContact;
        from: "CONTACT_SCREEN" | "IMPORT_CSV";
      } & {
        tag: ITag;
        contact: IContact;
        from: "FORM";
        form: IForm;
      } & { tag: ITag; contact: IContact; from: "FORM"; form: IForm } & {
        tag: ITag;
        contact: IContact;
        from: "CAMPAIGN";
        campaign: ICampaign;
      } & { tag: ITag; contact: IContact; from: "SOCIALLAIR"; lair: string } & {
        tag: ITag;
        contact: IContact;
        from: "LEARNISTIC";
      } & {
        form: IForm;
        contact: IContact;
        from: "FORM";
        externalUser: IExternalUser;
        description: string;
      } & {
        contact: IContact;
        from: "CONTACT_SCREEN";
      } & { contact: IContact; from: "EXTERNAL_API" } & {
        contact: IContact;
        from: "CONTACT_SCREEN";
        status: ContactStatus;
      } & {
        from: "CONTACT_SCREEN" | "EXTERNAL_API" | "IMPORT_CSV" | "LEARNISTIC";
        contact: IContact;
      } & {
        from: "FORM";
        contact: IContact;
        form: IForm;
      } & { from: "SOCIALLAIR"; contact: IContact; lair: string } & {
        from: "THRIVECART_WEBHOOK";
        contact: IContact;
        product: IProduct;
      });
  deviceInfo: IDeviceInfo;
  externalSystem?: "SOCIAL_LAIR";
}

export enum INoteTriggerCONTACTCREATED {
  CONTACT_CREATED = "CONTACT_CREATED",
  FORM_SUBMIT = "FORM_SUBMIT",
  STATUS = "STATUS",
  TAG_APPLIED = "TAG_APPLIED",
  TAG_REMOVED = "TAG_REMOVED",
  USER_NOTE = "USER_NOTE",
}

export type IRouterHandlerIRoute = object;

export type IRouterHandlerIRoute1 = object;

export interface PartialIEmail {
  _id?: ObjectIdSerialized;
  userUid?: string;
  body?: string;
  subject?: string;
  splitSubject?: string;
  splitMode?: "AGE" | "AGE_DOMAIN" | "DOMAIN";
  labels?: string[];
  isFavorite?: boolean;
  type?: IEmailType;
  toList?: string[];
  tagQuery?: ITagQuery;

  /** @format date-time */
  scheduleTo?: string;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
  emailHash?: string;

  /** @format date-time */
  emailSortDate?: string;
  event?: DefaultCalendarPropsIRoute;
  footerId?: string;
  aliasId?: string;
  footer?: IFooter;
  alias?: IAlias;
  searchId?: string;
  contactsSentTo?: IContact[];
  contactsSentToIdsAndVersionHashes?: {
    contactId: ObjectIdSerialized;
    contactVersionHash: ObjectIdSerialized;
  }[];
  showOnArchive?: boolean;
  resendMetadata?: { type: "unclicks" | "unopens"; originalEmailHash: string };
  defaultModeColorLink?: string;
  darkModeColorLink?: string;
  font?: IFontType;
  interestingURLs?: Record<string, string[]>;
}

export interface PartialIEmail1 {
  _id?: ObjectIdSerialized;
  userUid?: string;
  body?: string;
  subject?: string;
  splitSubject?: string;
  splitMode?: "AGE" | "AGE_DOMAIN" | "DOMAIN";
  labels?: string[];
  isFavorite?: boolean;
  type?: IEmailType;
  toList?: string[];
  tagQuery?: ITagQuery;

  /** @format date-time */
  scheduleTo?: string;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
  emailHash?: string;

  /** @format date-time */
  emailSortDate?: string;
  event?: DefaultCalendarPropsIRoute;
  footerId?: string;
  aliasId?: string;
  footer?: IFooter;
  alias?: IAlias;
  searchId?: string;
  contactsSentTo?: IContact[];
  contactsSentToIdsAndVersionHashes?: {
    contactId: ObjectIdSerialized;
    contactVersionHash: ObjectIdSerialized;
  }[];
  showOnArchive?: boolean;
  resendMetadata?: { type: "unclicks" | "unopens"; originalEmailHash: string };
  defaultModeColorLink?: string;
  darkModeColorLink?: string;
  font?: IFontType;
  interestingURLs?: Record<string, string[]>;
}

export interface PartialIDraftEmail {
  _id?: ObjectIdSerialized;
  userUid?: string;
  body?: string;
  subject?: string;
  splitSubject?: string;
  splitMode?: "AGE" | "AGE_DOMAIN" | "DOMAIN";
  labels?: string[];
  isFavorite?: boolean;
  type?: IEmailType;
  toList?: string[];
  tagQuery?: ITagQuery;

  /** @format date-time */
  scheduleTo?: string;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
  emailHash?: string;

  /** @format date-time */
  emailSortDate?: string;
  event?: DefaultCalendarPropsIRoute;
  footerId?: string;
  aliasId?: string;
  footer?: IFooter;
  alias?: IAlias;
  searchId?: string;
  contactsSentTo?: IContact[];
  contactsSentToIdsAndVersionHashes?: {
    contactId: ObjectIdSerialized;
    contactVersionHash: ObjectIdSerialized;
  }[];
  showOnArchive?: boolean;
  resendMetadata?: { type: "unclicks" | "unopens"; originalEmailHash: string };
  defaultModeColorLink?: string;
  darkModeColorLink?: string;
  font?: IFontType;
  interestingURLs?: Record<string, string[]>;
}

export interface PartialIArchive {
  _id?: ObjectIdSerialized;
  title?: string;
  showOptInForm?: boolean;
  userUid?: string;
  enabled?: boolean;
  period?: 10 | 180 | 30 | 365 | 60 | 90 | 9999;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(
      typeof value === "number" ? value : `${value}`
    )}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key]
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${
        queryString ? `?${queryString}` : ""
      }`,
      {
        ...requestParams,
        headers: {
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
          ...(requestParams.headers || {}),
        },
        signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Auth API
 * @version v0.1.0
 *
 * Documentation for the Auth API
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  auth = {
    /**
     * @description Check Email
     *
     * @name CheckEmailCreate
     * @request POST:/auth/check_email
     */
    checkEmailCreate: (body: { email: string }, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/check_email`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Create Account
     *
     * @name CreateAccountContactCreate
     * @request POST:/auth/create_account_contact
     */
    createAccountContactCreate: (
      body: { email: string; firstName: string; lastName: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/auth/create_account_contact`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Check User Origin
     *
     * @name CheckUserAccountCreate
     * @request POST:/auth/check_user_account
     */
    checkUserAccountCreate: (
      body: { phone: string; captchaResponse: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/auth/check_user_account`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name TemporaryPasscodeGenerateCreate
     * @request POST:/auth/temporary_passcode/generate
     */
    temporaryPasscodeGenerateCreate: (
      body: { phone: string; captchaResponse: string },
      params: RequestParams = {}
    ) =>
      this.request<{ status: string; data: { success: boolean } }, any>({
        path: `/auth/temporary_passcode/generate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TemporaryPasscodeCheckCreate
     * @request POST:/auth/temporary_passcode/check
     */
    temporaryPasscodeCheckCreate: (
      body: { phone: string; password: string },
      params: RequestParams = {}
    ) =>
      this.request<
        { status: string; data: { doesPasswordMatch: boolean } },
        any
      >({
        path: `/auth/temporary_passcode/check`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LoginCreate
     * @request POST:/auth/login
     */
    loginCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/login`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name InternalTokenDetail
     * @request GET:/auth/internal_token/{userUid}
     */
    internalTokenDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/internal_token/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckPhoneDetail
     * @request GET:/auth/check_phone/{phone}
     */
    checkPhoneDetail: (phone: string, params: RequestParams = {}) =>
      this.request<
        { status: string; data: { exists: true; type?: string } },
        any
      >({
        path: `/auth/check_phone/${phone}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TokenDetail
     * @request GET:/auth/token/{userUid}
     */
    tokenDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<{ status: string; data: { token: string } }, any>({
        path: `/auth/token/${userUid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthCreate
     * @request POST:/auth/
     */
    authCreate: (
      body: {
        phone: string;
        password: string;
        email: string;
        type: IUserAuthType;
        firstName: string;
        lastName: string;
        domain: string;
        alias: string;
        aliasName: string;
        userAppName: string;
        company: string;
        address: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/auth/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find user by appname
     *
     * @name CheckAppNameDetail
     * @request GET:/auth/check_app_name/{userAppName}
     */
    checkAppNameDetail: (userAppName: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/auth/check_app_name/${userAppName}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Check Email
     *
     * @name CheckUserEmailCreate
     * @request POST:/auth/check_user_email
     */
    checkUserEmailCreate: (
      body: { email: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/auth/check_user_email`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @name LearnisticTempPasscodeCreate
     * @request POST:/auth/learnistic/temp_passcode/{phone}
     */
    learnisticTempPasscodeCreate: (
      phone: string,
      body: { captchaResponse: string },
      params: RequestParams = {}
    ) =>
      this.request<{ status: string; data: { ok: boolean } }, any>({
        path: `/auth/learnistic/temp_passcode/${phone}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LearnisticLoginCreate
     * @request POST:/auth/learnistic/login
     */
    learnisticLoginCreate: (
      body: { phone: string; password: string },
      params: RequestParams = {}
    ) =>
      this.request<{ status: string; data: { ok: boolean } }, any>({
        path: `/auth/learnistic/login`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ResetPasscodeCreate
     * @request POST:/auth/reset_passcode
     */
    resetPasscodeCreate: (
      body: {
        type: "BERSERKER" | "INTERNAL" | "LEARNISTIC";
        phone: string;
        tempPassword: string;
        newPassword: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          status: string;
          data:
            | { ok: true; userUid: string }
            | { ok: false }
            | ({ ok: true; userUid: string } & { ok: false });
        },
        any
      >({
        path: `/auth/reset_passcode`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update password
     *
     * @name UpdatePasswordCreate
     * @request POST:/auth/update_password
     */
    updatePasswordCreate: (
      body: { phone: string; password: string; temporaryPassword: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/auth/update_password`,
        method: "POST",
        body: body,
        ...params,
      }),
  };
  search = {
    /**
     * @description Create a new Saved Search
     *
     * @name SearchCreate
     * @request POST:/search/
     */
    searchCreate: (
      body: {
        name: string;
        userUid: string;
        search: ITagQuery;
        footerId: string;
        publicArchive: boolean;
        labels: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/search/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find all searches that belongs to an user
     *
     * @name UserDetail
     * @request GET:/search/user/{userUid}
     */
    userDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/search/user/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name SearchDetail
     * @request GET:/search/{id}
     */
    searchDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/search/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name SearchUpdate
     * @request PUT:/search/{id}
     */
    searchUpdate: (
      id: string,
      body: {
        name: string;
        publicArchive: boolean;
        userUid: string;
        search?: ITagQuery;
        footerId?: string;
        labels?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/search/${id}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SearchDelete
     * @request DELETE:/search/{id}
     */
    searchDelete: (id: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/search/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateOrderUpdate
     * @request PUT:/search/updateOrder
     */
    updateOrderUpdate: (
      body: { newOrder: string[] },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/search/updateOrder`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  user = {
    /**
     * @description Create a user
     *
     * @name UserCreate
     * @request POST:/user/
     */
    userCreate: (
      body: {
        userUid: string;
        firstName: string;
        lastName: string;
        email: string;
        phone: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description List all users
     *
     * @name UserList
     * @request GET:/user/
     */
    userList: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name LoginCreate
     * @request POST:/user/login
     */
    loginCreate: (
      body: { phone: string; password: string; temporaryPassword: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/user/login`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckPhoneCreate
     * @request POST:/user/check_phone
     */
    checkPhoneCreate: (body: { phone: string }, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user/check_phone`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name InfoDetail
     * @request GET:/user/info/{uid}
     */
    infoDetail: (uid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user/info/${uid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description List overview of all email statuses
     *
     * @name OverviewDetail
     * @request GET:/user/overview/{userUid}
     */
    overviewDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/overview/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminCreate
     * @request POST:/user/admin
     */
    adminCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user/admin`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Find internal user by userUid
     *
     * @name InternalUserUidDetail
     * @request GET:/user/internalUserUid/{userUid}
     */
    internalUserUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user/internalUserUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Find internal user by userUid
     *
     * @name InternalUserManagedDetail
     * @request GET:/user/internalUser/managed/{userUid}
     */
    internalUserManagedDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user/internalUser/managed/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name InternalUserTokenCreate
     * @request POST:/user/internalUser/token
     */
    internalUserTokenCreate: (
      body: { internalUserUid: string; userUid: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/user/internalUser/token`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find user by userId
     *
     * @name UserUidDetail
     * @request GET:/user/userUid/{userUid}
     */
    userUidDetail: (
      id: string,
      userUid: string,
      userAppName: string,
      adminUid: string,
      email: string,
      phone: string,
      apiKey: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Find user by userId
     *
     * @name UserDetail
     * @request GET:/user/{_id}
     */
    userDetail: (
      id: string,
      userUid: string,
      userAppName: string,
      adminUid: string,
      email: string,
      phone: string,
      apiKey: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/{_id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Update user by user Id
     *
     * @name UserUpdate
     * @request PUT:/user/{_id}
     */
    userUpdate: (
      id: string,
      userUid: string,
      userAppName: string,
      adminUid: string,
      email: string,
      phone: string,
      apiKey: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/{_id}`,
        method: "PUT",
        ...params,
      }),

    /**
     * @description Delete user by user Id
     *
     * @name UserDelete
     * @request DELETE:/user/{_id}
     */
    userDelete: (
      id: string,
      userUid: string,
      userAppName: string,
      adminUid: string,
      email: string,
      phone: string,
      apiKey: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/{_id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Checks if api key is valid
     *
     * @name ApiKeyList
     * @request GET:/user/apiKey
     */
    apiKeyList: (body: { apiKey: string }, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/apiKey`,
        method: "GET",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get user restrictions
     *
     * @name RestrictionsDetail
     * @request GET:/user/{userUid}/restrictions
     */
    restrictionsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/${userUid}/restrictions`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Update user by user Id
     *
     * @name RestrictionsAddPartialUpdate
     * @request PATCH:/user/{userUid}/restrictions/add
     */
    restrictionsAddPartialUpdate: (
      userUid: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/${userUid}/restrictions/add`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Update user by user Id
     *
     * @name RestrictionsRemovePartialUpdate
     * @request PATCH:/user/{userUid}/restrictions/remove
     */
    restrictionsRemovePartialUpdate: (
      userUid: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/user/${userUid}/restrictions/remove`,
        method: "PATCH",
        ...params,
      }),
  };
  campaign = {
    /**
     * @description Create a new Campaign
     *
     * @name CampaignCreate
     * @request POST:/campaign/
     */
    campaignCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Edit a new Campaign
     *
     * @name EditCreate
     * @request POST:/campaign/edit/{campaignId}
     */
    editCreate: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/edit/${campaignId}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserUidDetail
     * @request GET:/campaign/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name PaginatedCreate
     * @request POST:/campaign/paginated/{userUid}
     */
    paginatedCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/paginated/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckNameCreate
     * @request POST:/campaign/checkName/{userUid}
     */
    checkNameCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/checkName/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name CampaignDetail
     * @request GET:/campaign/{campaignId}
     */
    campaignDetail: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/${campaignId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name CampaignUpdate
     * @request PUT:/campaign/{campaignId}
     */
    campaignUpdate: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/${campaignId}`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name CampaignDelete
     * @request DELETE:/campaign/{campaignId}
     */
    campaignDelete: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/${campaignId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name CloneDetail
     * @request GET:/campaign/{campaignId}/clone
     */
    cloneDetail: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/${campaignId}/clone`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name LaunchPartialUpdate
     * @request PATCH:/campaign/{campaignId}/launch
     */
    launchPartialUpdate: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/${campaignId}/launch`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatusPartialUpdate
     * @request PATCH:/campaign/{campaignId}/status
     */
    statusPartialUpdate: (
      campaignId: string,
      body: { status: ICampaignStatus },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/${campaignId}/status`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name RemoveAllContactsDelete
     * @request DELETE:/campaign/remove-all-contacts/{campaignId}
     */
    removeAllContactsDelete: (campaignId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaign/remove-all-contacts/${campaignId}`,
        method: "DELETE",
        ...params,
      }),
  };
  scheduledCampaign = {
    /**
     * @description Insert an contact into a campaign
     *
     * @name ByTagCreate
     * @request POST:/scheduledCampaign/byTag
     */
    byTagCreate: (
      body: {
        contactId: string;
        userUid: string;
        tagCondition: ITagConditions;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/scheduledCampaign/byTag`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name WebhookCreate
     * @request POST:/scheduledCampaign/webhook
     */
    webhookCreate: (
      body: { webhook: IWebHook; email: string; userUid: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/scheduledCampaign/webhook`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name LearnisticStartCampaignCreate
     * @request POST:/scheduledCampaign/learnistic/start_campaign
     */
    learnisticStartCampaignCreate: (
      body: {
        contactPhone?: string;
        contactEmail?: string;
        tagIds: number[];
        learnisticVirtualApp: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/scheduledCampaign/learnistic/start_campaign`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @name LearnisticStopCampaignCreate
     * @request POST:/scheduledCampaign/learnistic/stop_campaign
     */
    learnisticStopCampaignCreate: (
      body: {
        contactPhone?: string;
        contactEmail?: string;
        tagIds: number[];
        learnisticVirtualApp: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/scheduledCampaign/learnistic/stop_campaign`,
        method: "POST",
        body: body,
        ...params,
      }),
  };
  email = {
    /**
     * @description Create a new Email
     *
     * @name EmailCreate
     * @request POST:/email/
     */
    emailCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Create a new draft Email
     *
     * @name DraftCreate
     * @request POST:/email/draft
     */
    draftCreate: (body: CreateDraftEmailIRoute, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/draft`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserUidCountDetail
     * @request GET:/email/userUid/count/{userUid}/{fromEmailId}/{limit}
     */
    userUidCountDetail: (
      userUid: string,
      fromEmailSortDate: string,
      limit: string,
      filters: object,
      orderBy: "MOST_RECENT" | "OLDEST",
      filterBy: "ALL_TIME" | "NEXT_DAY" | "NEXT_MONTH" | "NEXT_WEEK",
      fromEmailId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/userUid/count/${userUid}/${fromEmailId}/${limit}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserUidCreate
     * @request POST:/email/userUid
     */
    userUidCreate: (
      body: {
        userUid: string;
        fromEmailSortDate?: string;
        limit?: string;
        filters?: {
          scheduled: boolean;
          sent: boolean;
          cancelled: boolean;
          labels: string[];
        };
        orderBy?: "MOST_RECENT" | "OLDEST";
        filterBy?: "ALL_TIME" | "NEXT_DAY" | "NEXT_MONTH" | "NEXT_WEEK";
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/userUid`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailDetail
     * @request GET:/email/{emailId}
     */
    emailDetail: (emailId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/${emailId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailUpdate
     * @request PUT:/email/{emailId}
     */
    emailUpdate: (emailId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/${emailId}`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailDelete
     * @request DELETE:/email/{emailId}
     */
    emailDelete: (emailId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/${emailId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name SummaryDetail
     * @request GET:/email/summary/{emailHash}
     */
    summaryDetail: (emailHash: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/summary/${emailHash}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name ShowArchiveCreate
     * @request POST:/email/show_archive
     */
    showArchiveCreate: (
      body: { emailId: string; showOnArchive: boolean },
      params: RequestParams = {}
    ) =>
      this.request<{ status: string; data: any }, any>({
        path: `/email/show_archive`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SimilarTimeCreate
     * @request POST:/email/similar_time
     */
    similarTimeCreate: (
      body: { userUid: string; timestamp: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/email/similar_time`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DraftUpdate
     * @request PUT:/email/draft/{emailId}
     */
    draftUpdate: (emailId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/draft/${emailId}`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArchiveDelete
     * @request DELETE:/email/archive/{emailId}
     */
    archiveDelete: (emailId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/archive/${emailId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name SplitDetailsDetail
     * @request GET:/email/split/details/{emailId}
     */
    splitDetailsDetail: (emailId: string, params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            splitData: {
              split: { contacts: string[]; averageAge: number }[];
              firstContactCreatedAt: string;
            };
          };
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/split/details/${emailId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get link preview
     *
     * @name LinkCreate
     * @request POST:/email/link
     */
    linkCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/link`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactCountCreate
     * @request POST:/email/contact/count
     */
    contactCountCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/email/contact/count`,
        method: "POST",
        ...params,
      }),
  };
  label = {
    /**
     * @description Create a new Label
     *
     * @name LabelCreate
     * @request POST:/label/
     */
    labelCreate: (
      body: {
        name: string;
        color: string;
        userUid: string;
        labelIndex: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/label/`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserUidDetail
     * @request GET:/label/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/label/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name LabelDetail
     * @request GET:/label/{labelId}
     */
    labelDetail: (labelId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/label/${labelId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name LabelUpdate
     * @request PUT:/label/{labelId}
     */
    labelUpdate: (
      labelId: string,
      body: {
        name: string;
        color: string;
        userUid: string;
        labelIndex: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/label/${labelId}`,
        method: "PUT",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @name LabelDelete
     * @request DELETE:/label/{labelId}
     */
    labelDelete: (labelId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/label/${labelId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateAllUpdate
     * @request PUT:/label/update-all
     */
    updateAllUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/label/update-all`,
        method: "PUT",
        ...params,
      }),
  };
  tag = {
    /**
     * @description Create a new tag
     *
     * @name PostTag
     * @request POST:/tag/
     */
    postTag: (
      body: { name: string; userUid: string; categoryId: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/tag/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update tag
     *
     * @name PatchTag
     * @request PATCH:/tag/
     */
    patchTag: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/tag/`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Find all tags from user
     *
     * @name UserUidDetail
     * @request GET:/tag/userUid/{userUid}
     */
    userUidDetail: (
      userUid: string,
      categoryId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/tag/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete tag and remove from all users
     *
     * @name DeleteTag
     * @request DELETE:/tag/{tagId}
     */
    deleteTag: (tagId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/tag/${tagId}`,
        method: "DELETE",
        ...params,
      }),
  };
  category = {
    /**
     * @description Create a new category
     *
     * @name CategoryCreate
     * @request POST:/category/
     */
    categoryCreate: (
      body: { name: string; userUid: string; type: ICategoryType },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/category/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update category
     *
     * @name CategoryPartialUpdate
     * @request PATCH:/category/
     */
    categoryPartialUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/category/`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Find all categories from user
     *
     * @name UserUidDetail
     * @request GET:/category/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/category/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete category and remove from all users
     *
     * @name CategoryDelete
     * @request DELETE:/category/{_id}
     */
    categoryDelete: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/category/{_id}`,
        method: "DELETE",
        ...params,
      }),
  };
  emailList = {
    /**
     * @description Create a new Email List
     *
     * @name EmailListCreate
     * @request POST:/emailList/
     */
    emailListCreate: (
      body: { name: string; userUid: string; emails: string[] },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/emailList/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserUidDetail
     * @request GET:/emailList/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/emailList/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailListDetail
     * @request GET:/emailList/{listId}
     */
    emailListDetail: (listId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/emailList/${listId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailListUpdate
     * @request PUT:/emailList/{listId}
     */
    emailListUpdate: (
      listId: string,
      body: { name: string; emails: string[] },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/emailList/${listId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailListDelete
     * @request DELETE:/emailList/{listId}
     */
    emailListDelete: (listId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/emailList/${listId}`,
        method: "DELETE",
        ...params,
      }),
  };
  contact = {
    /**
     * @description Create a new contact
     *
     * @name ContactCreate
     * @request POST:/contact/
     */
    contactCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Deletes contact array
     *
     * @name ContactDelete
     * @request DELETE:/contact/
     */
    contactDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Create a new contact
     *
     * @name FormCreate
     * @request POST:/contact/form
     */
    formCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/form`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Create a new contact
     *
     * @name ImportCreate
     * @request POST:/contact/import
     */
    importCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/import`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Check if any of the contacts has been created by the user
     *
     * @name CheckUserCreatedContactsCreate
     * @request POST:/contact/checkUserCreatedContacts
     */
    checkUserCreatedContactsCreate: (
      body: { contactIds: string[] },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/checkUserCreatedContacts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find all contacts from an user
     *
     * @name UserUidDetail
     * @request GET:/contact/userUid/{userUid}
     */
    userUidDetail: (
      userUid: string,
      limit: string,
      offset: string,
      labels: any,
      status: any,
      email: string,
      name: string,
      phone: string,
      statusOrder: string,
      createdAt: string,
      search: string,
      tagQuery: any,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Find all contacts from an user
     *
     * @name UserUidxCreate
     * @request POST:/contact/userUidx/{userUid}
     */
    userUidxCreate: (
      userUid: string,
      limit: string,
      offset: string,
      labels: any,
      status: any,
      email: string,
      name: string,
      phone: string,
      statusOrder: string,
      createdAt: string,
      search: string,
      tagQuery: any,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/userUidx/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Find a contact by it's Id
     *
     * @name UserUidDetail2
     * @request GET:/contact/{contactId}/userUid/{userUid}
     * @originalName userUidDetail
     * @duplicate
     */
    userUidDetail2: (
      contactId: string,
      email: string,
      userUid: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/${contactId}/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Updates a contact
     *
     * @name UserUidUpdate
     * @request PUT:/contact/{contactId}/userUid/{userUid}
     */
    userUidUpdate: (
      contactId: string,
      email: string,
      userUid: string,
      body: {
        name?: string;
        email?: string;
        labels?: string[];
        tags?: IContactTag[];
        avatar?: string;
        customFields?: any;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/${contactId}/userUid/${userUid}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description The forms that added the contact
     *
     * @name FormDetail
     * @request GET:/contact/{contactId}/form
     */
    formDetail: (contactId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/${contactId}/form`,
        method: "GET",
        ...params,
      }),

    /**
     * @description The forms that added the contact
     *
     * @name SetTestDriveCreate
     * @request POST:/contact/setTestDrive
     */
    setTestDriveCreate: (
      body: { userUid: string; contactId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/setTestDrive`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Getting TestDrive contact info
     *
     * @name TestDriveDetail
     * @request GET:/contact/testDrive/{userUid}
     */
    testDriveDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/testDrive/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get the contacts count applying a Tag Query to an user contacts.
     *
     * @name UserUidCountTagQueryCreate
     * @request POST:/contact/userUid/{userUid}/count/tagQuery
     */
    userUidCountTagQueryCreate: (
      contactId: string,
      email: string,
      userUid: string,
      body: { tagQueries: ITagQuery[] },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/userUid/${userUid}/count/tagQuery`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Unsubscribe users manually from your contacts.
     *
     * @name AdminUnsubCreate
     * @request POST:/contact/admin/unsub/{userUid}
     */
    adminUnsubCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/admin/unsub/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Unsubscribe users manually from your contacts.
     *
     * @name AdminSuspendCreate
     * @request POST:/contact/admin/suspend/{userUid}
     */
    adminSuspendCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/admin/suspend/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Manually change the contacts' status to 'not confirmed'.
     *
     * @name AdminNotConfirmedCreate
     * @request POST:/contact/admin/not-confirmed/{userUid}
     */
    adminNotConfirmedCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/admin/not-confirmed/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Unsuppress users manually from your contacts.
     *
     * @name AdminUnsuppressCreate
     * @request POST:/contact/admin/unsuppress/{userUid}
     */
    adminUnsuppressCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/admin/unsuppress/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Find a contact by it's email
     *
     * @name EmailUserUidDetail
     * @request GET:/contact/email/{email}/userUid/{userUid}
     */
    emailUserUidDetail: (
      contactId: string,
      email: string,
      userUid: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/email/${email}/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get all emails sent to a contact
     *
     * @name AllEmailsDetail
     * @request GET:/contact/all_emails/{contactId}
     */
    allEmailsDetail: (contactId: string, params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            _id: string;
            subject: string;
            body: string;
            aliasId: string;
            scheduleTo?: string;
            createdAt: string;
            type: string;
            status: "CLICKED" | "OPENED" | "REPORTED" | "UNOPENED";
            isPersonal?: boolean;
          }[];
        },
        any
      >({
        path: `/contact/all_emails/${contactId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Send email confirmation
     *
     * @name ConfirmationUserUidCreate
     * @request POST:/contact/confirmation/userUid/{userUid}
     */
    confirmationUserUidCreate: (
      contactId: string,
      email: string,
      userUid: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/confirmation/userUid/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Adds a tag to the contact
     *
     * @name TagUserUidPartialUpdate
     * @request PATCH:/contact/{contactId}/tag/userUid/{userUid}
     */
    tagUserUidPartialUpdate: (
      contactId: string,
      email: string,
      userUid: string,
      body: { tag: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/${contactId}/tag/userUid/${userUid}`,
        method: "PATCH",
        body: body,
        ...params,
      }),

    /**
     * @description Adds a tag to the contact by email
     *
     * @name EmailTagUserUidPartialUpdate
     * @request PATCH:/contact/email/{email}/tag/userUid/{userUid}
     */
    emailTagUserUidPartialUpdate: (
      contactId: string,
      email: string,
      userUid: string,
      body: { tag: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/email/${email}/tag/userUid/${userUid}`,
        method: "PATCH",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @name ImportUserUidPartialUpdate
     * @request PATCH:/contact/import/userUid/{userUid}
     */
    importUserUidPartialUpdate: (
      userUid: string,
      limit: string,
      offset: string,
      labels: any,
      status: any,
      email: string,
      name: string,
      phone: string,
      statusOrder: string,
      createdAt: string,
      search: string,
      tagQuery: any,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/import/userUid/${userUid}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Removes a tag from a contact
     *
     * @name TagUserUidRemovePartialUpdate
     * @request PATCH:/contact/{contactId}/tag/userUid/{userUid}/remove
     */
    tagUserUidRemovePartialUpdate: (
      contactId: string,
      email: string,
      userUid: string,
      body: { tag: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/${contactId}/tag/userUid/${userUid}/remove`,
        method: "PATCH",
        body: body,
        ...params,
      }),

    /**
     * @description Removes many tags from many contacts
     *
     * @name ManyTagUserUidRemovePartialUpdate
     * @request PATCH:/contact/many/tag/userUid/{userUid}/remove
     */
    manyTagUserUidRemovePartialUpdate: (
      userUid: string,
      limit: string,
      offset: string,
      labels: any,
      status: any,
      email: string,
      name: string,
      phone: string,
      statusOrder: string,
      createdAt: string,
      search: string,
      tagQuery: any,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/many/tag/userUid/${userUid}/remove`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Add and Remove many tags from many contacts
     *
     * @name ManyTagUserUidAddRemovePartialUpdate
     * @request PATCH:/contact/many/tag/userUid/{userUid}/add-remove
     */
    manyTagUserUidAddRemovePartialUpdate: (
      userUid: string,
      limit: string,
      offset: string,
      labels: any,
      status: any,
      email: string,
      name: string,
      phone: string,
      statusOrder: string,
      createdAt: string,
      search: string,
      tagQuery: any,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/many/tag/userUid/${userUid}/add-remove`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Add and Remove many labels from many contacts
     *
     * @name ManyLabelAddRemovePartialUpdate
     * @request PATCH:/contact/many/label/{userUid}/add-remove
     */
    manyLabelAddRemovePartialUpdate: (
      userUid: string,
      limit: string,
      offset: string,
      labels: any,
      status: any,
      email: string,
      name: string,
      phone: string,
      statusOrder: string,
      createdAt: string,
      search: string,
      tagQuery: any,
      body: {
        addLabelIds: string[];
        removeLabelIds: string[];
        contacts?: string[];
        query?: FindAllContactIRoute;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/contact/many/label/${userUid}/add-remove`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a contact
     *
     * @name ContactDelete2
     * @request DELETE:/contact/{contactId}
     * @originalName contactDelete
     * @duplicate
     */
    contactDelete2: (contactId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/${contactId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Check delete contact array
     *
     * @name CheckDeleteCountCreate
     * @request POST:/contact/checkDeleteCount
     */
    checkDeleteCountCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/checkDeleteCount`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Dumps all contacts
     *
     * @name DumpDetail
     * @request GET:/contact/dump/{userUid}
     */
    dumpDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/contact/dump/${userUid}`,
        method: "GET",
        ...params,
      }),
  };
  endpoint = {
    /**
     * @description Create a new contact
     *
     * @name ContactCreate
     * @request POST:/endpoint/contact
     */
    contactCreate: (
      body: {
        name: string;
        email: string;
        labels?: string[];
        tags?: string[];
        avatar?: string;
        status?: ContactStatus;
        lairName: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/contact`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find a contact by it's email
     *
     * @name ContactEmailDetail
     * @request GET:/endpoint/contact/email/{email}
     */
    contactEmailDetail: (
      contactId: string,
      email: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/contact/email/${email}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Checks if api key is valid
     *
     * @name UserApiKeyList
     * @request GET:/endpoint/user/apiKey
     */
    userApiKeyList: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/user/apiKey`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Adds a tag to the contact
     *
     * @name ContactTagPartialUpdate
     * @request PATCH:/endpoint/contact/{contactId}/tag
     */
    contactTagPartialUpdate: (
      contactId: string,
      email: string,
      body: { tag: string; lairName: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/contact/${contactId}/tag`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find all tags from user by authorization
     *
     * @name TagsList
     * @request GET:/endpoint/tags
     */
    tagsList: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/tags`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Create a new tag
     *
     * @name TagsCreate
     * @request POST:/endpoint/tags
     */
    tagsCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/tags`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Update a tag
     *
     * @name TagsPartialUpdate
     * @request PATCH:/endpoint/tags
     */
    tagsPartialUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/tags`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Find all tags from user by authorization
     *
     * @name UnsubscribedDetail
     * @request GET:/endpoint/unsubscribed/{contactId}
     */
    unsubscribedDetail: (
      contactId: string,
      email: string,
      query?: { emailHash?: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/unsubscribed/${contactId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Confirm contact email
     *
     * @name ConfirmDetail
     * @request GET:/endpoint/confirm/{contactId}
     */
    confirmDetail: (
      contactId: string,
      email: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/endpoint/confirm/${contactId}`,
        method: "GET",
        ...params,
      }),
  };
  version = {
    /**
     * No description
     *
     * @name VersionList
     * @request GET:/version
     */
    versionList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/version`,
        method: "GET",
        ...params,
      }),
  };
  mailgun = {
    /**
     * No description
     *
     * @name WebhookCreate
     * @request POST:/mailgun/webhook
     */
    webhookCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/mailgun/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Create a new tag
     *
     * @name UserUidDetail
     * @request GET:/mailgun/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/mailgun/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),
  };
  thrivecart = {
    /**
     * No description
     *
     * @name AccountNameDetail
     * @request GET:/thrivecart/account_name/{apiKey}
     */
    accountNameDetail: (apiKey: string, params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            account_name: string;
            account_id: string;
            account_version: string;
            account_url: string;
            user_id: string;
            user_username: string;
            user_name: string;
            custom_domain_enabled: boolean;
            custom_domain?: any;
          };
        },
        any
      >({
        path: `/thrivecart/account_name/${apiKey}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductsDetail
     * @request GET:/thrivecart/products/{userUid}
     */
    productsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            product_id: string;
            name: string;
            label?: string;
            url?: string;
            embed_type?: string;
            status?: string;
            statusString?: string;
            type?: string;
            typeString?: string;
          }[];
        },
        any
      >({
        path: `/thrivecart/products/${userUid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpsellsDetail
     * @request GET:/thrivecart/upsells/{userUid}
     */
    upsellsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            upsell_id: string;
            name: string;
            label?: string;
            url?: string;
            embed_type?: string;
            status?: string;
            statusString?: string;
            type?: string;
            typeString?: string;
          }[];
        },
        any
      >({
        path: `/thrivecart/upsells/${userUid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name BumpsDetail
     * @request GET:/thrivecart/bumps/{userUid}
     */
    bumpsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            bump_id: string;
            name: string;
            label?: string;
            url?: string;
            embed_type?: string;
            status?: string;
            statusString?: string;
            type?: string;
            typeString?: string;
          }[];
        },
        any
      >({
        path: `/thrivecart/bumps/${userUid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DownsellsDetail
     * @request GET:/thrivecart/downsells/{userUid}
     */
    downsellsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            downsell_id: string;
            name: string;
            label?: string;
            type?: string;
            typeString?: string;
          }[];
        },
        any
      >({
        path: `/thrivecart/downsells/${userUid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name HeadThrivecart
     * @request HEAD:/thrivecart/webhook
     */
    headThrivecart: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/thrivecart/webhook`,
        method: "HEAD",
        ...params,
      }),

    /**
     * No description
     *
     * @name WebhookCreate
     * @request POST:/thrivecart/webhook
     */
    webhookCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/thrivecart/webhook`,
        method: "POST",
        ...params,
      }),
  };
  form = {
    /**
     * @description Create a new form
     *
     * @name FormCreate
     * @request POST:/form/
     */
    formCreate: (
      body: {
        name: string;
        userUid: string;
        nameType: FormNameType;
        tags: string[];
        submitted?: number;
        formTagId?: string;
        viewed?: number;
        url: string;
        isInternal?: boolean;
        externalUsers?: string[];
        description?: string;
        builder?: any;
        hasBuilder?: boolean;
        hasThankYouBuilder?: boolean;
        thankYouBuilder?: any;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update form
     *
     * @name FormPartialUpdate
     * @request PATCH:/form/
     */
    formPartialUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Find all forms from user
     *
     * @name UserUidDetail
     * @request GET:/form/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Find a forms based on its id
     *
     * @name FormDetail
     * @request GET:/form/{formId}
     */
    formDetail: (formId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/${formId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete form and remove from all users
     *
     * @name FormDelete
     * @request DELETE:/form/{formId}
     */
    formDelete: (formId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/${formId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Find a forms based on its id
     *
     * @name FromNameDetail
     * @request GET:/form/fromName/{appName}/{formName}
     */
    fromNameDetail: (
      appName: string,
      formName: string,
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/fromName/${appName}/${formName}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Find a forms based on its id and returns rendering information
     *
     * @name RenderDetail
     * @request GET:/form/render/{formId}
     */
    renderDetail: (formId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/render/${formId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Pixel for forms to track the view count
     *
     * @name PixelDetail
     * @request GET:/form/pixel/{formId}
     */
    pixelDetail: (formId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/pixel/${formId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete form and remove from all users
     *
     * @name CloneCreate
     * @request POST:/form/clone
     */
    cloneCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/form/clone`,
        method: "POST",
        ...params,
      }),
  };
  link = {
    /**
     * @description Create a new Label
     *
     * @name LinkCreate
     * @request POST:/link/
     */
    linkCreate: (
      body: {
        externalId: number;
        name: string;
        userUid: string;
        createdAt?: string;
        url: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/link/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserUidDetail
     * @request GET:/link/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/link/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name LinkDelete
     * @request DELETE:/link/{linkId}
     */
    linkDelete: (linkId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/link/${linkId}`,
        method: "DELETE",
        ...params,
      }),
  };
  note = {
    /**
     * @description Create a new Note
     *
     * @name NoteCreate
     * @request POST:/note/
     */
    noteCreate: (body: CreateNoteIRoute, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/note/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get notes of a contact
     *
     * @name ContactDetail
     * @request GET:/note/contact/{contactId}
     */
    contactDetail: (contactId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/note/contact/${contactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get user notes
     *
     * @name UserNoteDetail
     * @request GET:/note/userNote/{userUid}
     */
    userNoteDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/note/userNote/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Create user notes
     *
     * @name UserNoteCreate
     * @request POST:/note/userNote
     */
    userNoteCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/note/userNote`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Create user notes
     *
     * @name UserNoteContactsSelectedCreate
     * @request POST:/note/userNote/contacts-selected
     */
    userNoteContactsSelectedCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/note/userNote/contacts-selected`,
        method: "POST",
        ...params,
      }),
  };
  noteCategory = {
    /**
     * @description Create a new note category
     *
     * @name NoteCategoryCreate
     * @request POST:/noteCategory/
     */
    noteCategoryCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/noteCategory/`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Update note category
     *
     * @name NoteCategoryPartialUpdate
     * @request PATCH:/noteCategory/
     */
    noteCategoryPartialUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/noteCategory/`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Find all categories from user
     *
     * @name UserUidDetail
     * @request GET:/noteCategory/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/noteCategory/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete note category and remove from all users
     *
     * @name NoteCategoryDelete
     * @request DELETE:/noteCategory/{_id}
     */
    noteCategoryDelete: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/noteCategory/{_id}`,
        method: "DELETE",
        ...params,
      }),
  };
  externalUser = {
    /**
     * @description Create a new externalUser
     *
     * @name ExternalUserCreate
     * @request POST:/externalUser/
     */
    externalUserCreate: (
      body: { name: string; mainUserUid: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/externalUser/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update externalUser
     *
     * @name ExternalUserPartialUpdate
     * @request PATCH:/externalUser/
     */
    externalUserPartialUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/externalUser/`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Find all externalUsers from user
     *
     * @name UserUidDetail
     * @request GET:/externalUser/userUid/{mainUserUid}
     */
    userUidDetail: (mainUserUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/externalUser/userUid/${mainUserUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete externalUser and remove from all users
     *
     * @name ExternalUserDelete
     * @request DELETE:/externalUser/{externalUserId}
     */
    externalUserDelete: (externalUserId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/externalUser/${externalUserId}`,
        method: "DELETE",
        ...params,
      }),
  };
  calendar = {
    /**
     * @description Generate an ics file
     *
     * @name GetCalendar
     * @request GET:/calendar/i/{emailUid}
     */
    getCalendar: (emailUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/calendar/i/${emailUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Generate an ics file
     *
     * @name IDownloadDetail
     * @request GET:/calendar/i/download/{emailUid}
     */
    iDownloadDetail: (emailUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/calendar/i/download/${emailUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Create a new event in Yahoo Calendar
     *
     * @name GetCalendar2
     * @request GET:/calendar/y/{emailUid}
     * @originalName getCalendar
     * @duplicate
     */
    getCalendar2: (emailUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/calendar/y/${emailUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Create a new event in Google Calendar
     *
     * @name GetCalendar3
     * @request GET:/calendar/g/{emailUid}
     * @originalName getCalendar
     * @duplicate
     */
    getCalendar3: (emailUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/calendar/g/${emailUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Redirect from Google Calendar
     *
     * @name GoogleRedirectList
     * @request GET:/calendar/google/redirect
     */
    googleRedirectList: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/calendar/google/redirect`,
        method: "GET",
        ...params,
      }),
  };
  campaignStep = {
    /**
     * @description Create a new campaign step
     *
     * @name CampaignStepCreate
     * @request POST:/campaignStep/
     */
    campaignStepCreate: (
      body: {
        node: {
          _id?: ObjectId | string;
          name: string;
          type: INodeTypes;
          email?: IEmailAction;
          manageTag?: IManageTag;
          stopTag?: IStopTag;
          delayTimer?: IDelayTimer;
          dateTimer?: IDateTimer;
          sms?: ISms;
          pushNotification?: IPushNotification;
          webHook?: IWebHook;
          setField?: ISetField;
          applyNote?: IApplyNote;
          filter?: IFilter;
        };
        contactId: ObjectId | string;
        campaign: ICampaign;
        enteredAt: string;
        current: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaignStep/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find all campaign steps from contact
     *
     * @name ContactIdDetail
     * @request GET:/campaignStep/contactId/{contactId}
     */
    contactIdDetail: (contactId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/campaignStep/contactId/${contactId}`,
        method: "GET",
        ...params,
      }),
  };
  billing = {
    /**
     * @description Get Billing Info
     *
     * @name BillingDetail
     * @request GET:/billing/{userUid}
     */
    billingDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/billing/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Adds a stripe customer to the user
     *
     * @name CustomerCreate
     * @request POST:/billing/customer
     */
    customerCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/billing/customer`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Adds a stripe customer to the user
     *
     * @name CustomerPartialUpdate
     * @request PATCH:/billing/customer/{userUid}
     */
    customerPartialUpdate: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/billing/customer/${userUid}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * @description Starts a Stripe subscription
     *
     * @name SubscriptionCreate
     * @request POST:/billing/subscription
     */
    subscriptionCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/billing/subscription`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Starts a Stripe subscription
     *
     * @name SubscriptionUpdate
     * @request PUT:/billing/subscription
     */
    subscriptionUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/billing/subscription`,
        method: "PUT",
        ...params,
      }),

    /**
     * @description Cancells a subscription
     *
     * @name SubscriptionDelete
     * @request DELETE:/billing/subscription/{userUid}
     */
    subscriptionDelete: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/billing/subscription/${userUid}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Add a new payment method and set default
     *
     * @name PaymentMethodCreate
     * @request POST:/billing/paymentMethod/{userUid}
     */
    paymentMethodCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/paymentMethod/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Get default price
     *
     * @name PriceDetail
     * @request GET:/billing/price/{userUid}
     */
    priceDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/price/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get default price
     *
     * @name TestDriveCreate
     * @request POST:/billing/testDrive
     */
    testDriveCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/testDrive`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Get Upsells price
     *
     * @name UpsellsList
     * @request GET:/billing/upsells
     */
    upsellsList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/upsells`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get Upsells price
     *
     * @name UpsellCreate
     * @request POST:/billing/upsell
     */
    upsellCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/upsell`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Flags that the user is able to receive an invoice
     *
     * @name UpsellDoneDetail
     * @request GET:/billing/upsellDone/{userUid}
     */
    upsellDoneDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/upsellDone/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeDelete
     * @request DELETE:/billing/stripe
     */
    stripeDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripe`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeList
     * @request GET:/billing/stripe
     */
    stripeList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripe`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name HeadBilling
     * @request HEAD:/billing/stripe
     */
    headBilling: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripe`,
        method: "HEAD",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripePartialUpdate
     * @request PATCH:/billing/stripe
     */
    stripePartialUpdate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripe`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeCreate
     * @request POST:/billing/stripe
     */
    stripeCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripe`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeUpdate
     * @request PUT:/billing/stripe
     */
    stripeUpdate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripe`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name OptionsBilling
     * @request OPTIONS:/billing/stripe
     */
    optionsBilling: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripe`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * No description
     *
     * @name StripeInvoiceCreate
     * @request POST:/billing/stripeInvoice
     */
    stripeInvoiceCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/stripeInvoice`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name RecurringDelete
     * @request DELETE:/billing/recurring
     */
    recurringDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/recurring`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name RecurringList
     * @request GET:/billing/recurring
     */
    recurringList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/recurring`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name HeadBilling2
     * @request HEAD:/billing/recurring
     * @originalName headBilling
     * @duplicate
     */
    headBilling2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/recurring`,
        method: "HEAD",
        ...params,
      }),

    /**
     * No description
     *
     * @name RecurringPartialUpdate
     * @request PATCH:/billing/recurring
     */
    recurringPartialUpdate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/recurring`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name RecurringCreate
     * @request POST:/billing/recurring
     */
    recurringCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/recurring`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name RecurringUpdate
     * @request PUT:/billing/recurring
     */
    recurringUpdate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/recurring`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name OptionsBilling2
     * @request OPTIONS:/billing/recurring
     * @originalName optionsBilling
     * @duplicate
     */
    optionsBilling2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/recurring`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * No description
     *
     * @name BillingFailureCreate
     * @request POST:/billing/billingFailure
     */
    billingFailureCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/billing/billingFailure`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateCustomerPortalSessionDetail
     * @request GET:/billing/create-customer-portal-session/{uid}
     */
    createCustomerPortalSessionDetail: (
      uid: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/billing/create-customer-portal-session/${uid}`,
        method: "GET",
        ...params,
      }),
  };
  helpVideo = {
    /**
     * No description
     *
     * @name HelpVideoDetail
     * @request GET:/help_video/{videoContext}
     */
    helpVideoDetail: (videoContext: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/help_video/${videoContext}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get all videos
     *
     * @name GetHelpVideo
     * @request GET:/help_video/all
     */
    getHelpVideo: (params: RequestParams = {}) =>
      this.request<
        {
          status: string;
          data: {
            _id: string;
            videoContext: string;
            videoUrl: string;
            enabled: boolean;
          }[];
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/help_video/all`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update video
     *
     * @name UpdateUpdate
     * @request PUT:/help_video/update
     */
    updateUpdate: (
      body: {
        _id: string;
        videoContext: string;
        videoUrl: string;
        enabled: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/help_video/update`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update many videos
     *
     * @name ManyUpdate
     * @request PUT:/help_video/many
     */
    manyUpdate: (body: { videos: IHelpVideo[] }, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/help_video/many`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  admin = {
    /**
     * @description Login
     *
     * @name LoginCreate
     * @request POST:/admin/login
     */
    loginCreate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/admin/login`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name UsersCreate
     * @request POST:/admin/users
     */
    usersCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/users`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactsCreate
     * @request POST:/admin/contacts/{userUid}
     */
    contactsCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/contacts/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TagsCreate
     * @request POST:/admin/tags/{userUid}
     */
    tagsCreate: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/tags/${userUid}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name PostAdmin
     * @request POST:/admin/tag
     */
    postAdmin: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/tag`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactsUpdatePartialUpdate
     * @request PATCH:/admin/contacts/update
     */
    contactsUpdatePartialUpdate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/contacts/update`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryCreate
     * @request POST:/admin/category
     */
    categoryCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/category`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name UsersCreate2
     * @request POST:/admin/users/{email}
     * @originalName usersCreate
     * @duplicate
     */
    usersCreate2: (email: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/users/${email}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name RateLimitsDetail
     * @request GET:/admin/rate_limits/{userUid}
     */
    rateLimitsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/rate_limits/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name RateLimitsCreate
     * @request POST:/admin/rate_limits
     */
    rateLimitsCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/rate_limits`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ExternalLoginCreate
     * @request POST:/admin/external_login
     */
    externalLoginCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/external_login`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TogglePirateCreate
     * @request POST:/admin/togglePirate
     */
    togglePirateCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/togglePirate`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ToggleDomainCreate
     * @request POST:/admin/toggleDomain
     */
    toggleDomainCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin/toggleDomain`,
        method: "POST",
        ...params,
      }),
  };
  integration = {
    /**
     * No description
     *
     * @name GetIntegration
     * @request GET:/integration/all/{userUid}
     */
    getIntegration: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/integration/all/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name IntegrationCreate
     * @request POST:/integration/
     */
    integrationCreate: (
      body: {
        userUid: string;
        integration:
          | IThrivecartIntegration
          | ILearnisticIntegration
          | (IThrivecartIntegration & ILearnisticIntegration);
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/integration/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name IntegrationPartialUpdate
     * @request PATCH:/integration/
     */
    integrationPartialUpdate: (
      body: {
        userUid: string;
        integrationId: string;
        integration:
          | (ReadonlyPartialIThrivecartIntegration &
              Record<string, AssignableType>)
          | (ReadonlyPartialILearnisticIntegration &
              Record<string, AssignableType>)
          | ((ReadonlyPartialIThrivecartIntegration &
              Record<string, AssignableType>) &
              (ReadonlyPartialILearnisticIntegration &
                Record<string, AssignableType>));
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/integration/`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name IntegrationDelete
     * @request DELETE:/integration/{integrationId}
     */
    integrationDelete: (integrationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/integration/${integrationId}`,
        method: "DELETE",
        ...params,
      }),
  };
  products = {
    /**
     * No description
     *
     * @name IntegrationAllDetail
     * @request GET:/products/integration_all/{userUid}/{type}
     */
    integrationAllDetail: (
      userUid: string,
      type: any,
      params: RequestParams = {}
    ) =>
      this.request<
        {
          status: string;
          data: {
            _id?: string;
            productId: string;
            productName: string;
            type: "THRIVECART";
            productTypeId: string;
            userUid: string;
            tagIds: string[];
          }[];
        },
        any
      >({
        path: `/products/integration_all/${userUid}/${type}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductsCreate
     * @request POST:/products/
     */
    productsCreate: (
      body: { userUid: string; product: IProduct },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/products/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductsPartialUpdate
     * @request PATCH:/products/
     */
    productsPartialUpdate: (
      body: { userUid: string; productId: string; product: PartialIProduct },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/products/`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductsDelete
     * @request DELETE:/products/{productId}
     */
    productsDelete: (productId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/products/${productId}`,
        method: "DELETE",
        ...params,
      }),
  };
  archive = {
    /**
     * No description
     *
     * @name ArchiveDetail
     * @request GET:/archive/{userUid}
     */
    archiveDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/archive/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailsDetail
     * @request GET:/archive/emails/{archiveName}
     */
    emailsDetail: (archiveName: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/archive/emails/${archiveName}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArchivePartialUpdate
     * @request PATCH:/archive/
     */
    archivePartialUpdate: (
      body: { userUid: string; archive: PartialIArchive },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/archive/`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  contactsBackup = {
    /**
     * @description Update backup to downloaded
     *
     * @name ContactsBackupPartialUpdate
     * @request PATCH:/contactsBackup/
     */
    contactsBackupPartialUpdate: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/contactsBackup/`,
        method: "PATCH",
        ...params,
      }),
  };
  learnistic = {
    /**
     * @description Create a learnistic integration
     *
     * @name LearnisticCreate
     * @request POST:/learnistic/
     */
    learnisticCreate: (
      body: { userUid: string; phoneNumber: string; passcode: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/learnistic/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get learnistic integration
     *
     * @name LearnisticDetail
     * @request GET:/learnistic/{userUid}
     */
    learnisticDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/learnistic/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get learnistic integration
     *
     * @name LearnisticPartialUpdate
     * @request PATCH:/learnistic/{userUid}
     */
    learnisticPartialUpdate: (
      userUid: string,
      body: { vAppIds: string[] },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/learnistic/${userUid}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete learnistic integration
     *
     * @name LearnisticDelete
     * @request DELETE:/learnistic/{userUid}
     */
    learnisticDelete: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/learnistic/${userUid}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get user owner learnistic tags
     *
     * @name TagsDetail
     * @request GET:/learnistic/tags/{userUid}
     */
    tagsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/learnistic/tags/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get user owner learnistic tags
     *
     * @name AppsDetail
     * @request GET:/learnistic/apps/{userUid}
     */
    appsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/learnistic/apps/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Get user owner learnistic tags
     *
     * @name TestDeleteDelete
     * @request DELETE:/learnistic/testDelete
     */
    testDeleteDelete: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/learnistic/testDelete`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateContactsDetail
     * @request GET:/learnistic/updateContacts/{userUid}
     */
    updateContactsDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/learnistic/updateContacts/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailCreate
     * @request POST:/learnistic/email
     */
    emailCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/learnistic/email`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactCreateCreate
     * @request POST:/learnistic/contact/create
     */
    contactCreateCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/learnistic/contact/create`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactDelete
     * @request DELETE:/learnistic/contact
     */
    contactDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/learnistic/contact`,
        method: "DELETE",
        ...params,
      }),
  };
  triggers = {
    /**
     * @description Create a new automation trigger
     *
     * @name TriggersCreate
     * @request POST:/triggers/
     */
    triggersCreate: (
      body: {
        userUid: string;
        type: "UNSUBSCRIBE";
        addedTags: ITagWithoutExternalId[];
        removedTags: ITagWithoutExternalId[];
        addedLearnisticTags: ILearnisticApp[];
        removedLearnisticTags: ILearnisticApp[];
        learnisticAppsToRemove: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/triggers/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Find all triggers from user
     *
     * @name UserUidDetail
     * @request GET:/triggers/userUid/{userUid}
     */
    userUidDetail: (userUid: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/triggers/userUid/${userUid}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Update trigger
     *
     * @name TriggersPartialUpdate
     * @request PATCH:/triggers/{triggerId}
     */
    triggersPartialUpdate: (
      triggerId: string,
      body: {
        addedTags?: ITagWithoutExternalId[];
        removedTags?: ITagWithoutExternalId[];
        addedLearnisticTags?: ILearnisticApp[];
        removedLearnisticTags?: ILearnisticApp[];
        learnisticAppsToRemove?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/triggers/${triggerId}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete tag and remove from all users
     *
     * @name TriggersDelete
     * @request DELETE:/triggers/{triggerId}
     */
    triggersDelete: (triggerId: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/triggers/${triggerId}`,
        method: "DELETE",
        ...params,
      }),
  };
  captcha = {
    /**
     * No description
     *
     * @name CaptchaList
     * @request GET:/captcha/
     */
    captchaList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/captcha/`,
        method: "GET",
        ...params,
      }),
  };
  helpscout = {
    /**
     * No description
     *
     * @name HelpscoutCreate
     * @request POST:/helpscout/
     */
    helpscoutCreate: (
      body: { fullname: string; question: string; email: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/helpscout/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  externalApi = {
    /**
     * @description Get user info
     *
     * @tags User
     * @name UserList
     * @request GET:/external-api/user
     */
    userList: (params: RequestParams = {}) =>
      this.request<
        {
          status: "ok";
          data: {
            email: string;
            firstName: string;
            lastName: string;
            userUid: string;
          };
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Upsert a contact
     *
     * @tags Contacts
     * @name ContactPartialUpdate
     * @request PATCH:/external-api/contact
     */
    contactPartialUpdate: (
      body: {
        firstName?: string;
        lastName?: string;
        email: string;
        phone?: string;
        tags?: string[];
        status?: ContactStatus;
        billingStreet1?: string;
        billingStreet2?: string;
        billingCity?: string;
        billingCountry?: string;
        billingState?: string;
        billingPostalCode?: string;
        billingPhoneCountryCode?: string;
        billingPhone?: string;
        shippingStreet1?: string;
        shippingStreet2?: string;
        shippingCity?: string;
        shippingCountry?: string;
        shippingState?: string;
        shippingPostalCode?: string;
        shippingPhoneCountryCode?: string;
        shippingPhone?: string;
        customFields?: any;
        shouldOverwrite?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          status: "ok";
          data: {
            _id: string;
            email: string;
            firstName: string;
            lastName: string;
            tags: { _id: string; appliedAt: string }[];
            phone: string;
            status: string;
            billingStreet1?: string;
            billingStreet2?: string;
            billingCity?: string;
            billingCountry?: string;
            billingState?: string;
            billingPostalCode?: string;
            billingPhoneCountryCode?: string;
            billingPhone?: string;
            shippingStreet1?: string;
            shippingStreet2?: string;
            shippingCity?: string;
            shippingCountry?: string;
            shippingState?: string;
            shippingPostalCode?: string;
            shippingPhoneCountryCode?: string;
            shippingPhone?: string;
          };
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/contact`,
        method: "PATCH",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a contact
     *
     * @tags Contacts
     * @name ContactCreate
     * @request POST:/external-api/contact
     */
    contactCreate: (
      body: {
        firstName?: string;
        lastName?: string;
        email: string;
        phone?: string;
        tags?: string[];
        status?: ContactStatus;
        billingStreet1?: string;
        billingStreet2?: string;
        billingCity?: string;
        billingCountry?: string;
        billingState?: string;
        billingPostalCode?: string;
        billingPhoneCountryCode?: string;
        billingPhone?: string;
        shippingStreet1?: string;
        shippingStreet2?: string;
        shippingCity?: string;
        shippingCountry?: string;
        shippingState?: string;
        shippingPostalCode?: string;
        shippingPhoneCountryCode?: string;
        shippingPhone?: string;
        customFields?: any;
        shouldOverwrite?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          status: "ok";
          data: {
            _id: string;
            email: string;
            firstName: string;
            lastName: string;
            tags: { _id: string; appliedAt: string }[];
            phone: string;
            status: string;
            billingStreet1?: string;
            billingStreet2?: string;
            billingCity?: string;
            billingCountry?: string;
            billingState?: string;
            billingPostalCode?: string;
            billingPhoneCountryCode?: string;
            billingPhone?: string;
            shippingStreet1?: string;
            shippingStreet2?: string;
            shippingCity?: string;
            shippingCountry?: string;
            shippingState?: string;
            shippingPostalCode?: string;
            shippingPhoneCountryCode?: string;
            shippingPhone?: string;
          };
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/contact`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),

    /**
     * @description Get contacts
     *
     * @tags Contacts
     * @name ContactList
     * @request GET:/external-api/contact
     */
    contactList: (
      body: { offset: string; tagId?: string },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          status: "ok";
          data: {
            _id: string;
            email: string;
            firstName: string;
            lastName: string;
            tags: { _id: string; appliedAt: string }[];
            phone: string;
            status: string;
            billingStreet1?: string;
            billingStreet2?: string;
            billingCity?: string;
            billingCountry?: string;
            billingState?: string;
            billingPostalCode?: string;
            billingPhoneCountryCode?: string;
            billingPhone?: string;
            shippingStreet1?: string;
            shippingStreet2?: string;
            shippingCity?: string;
            shippingCountry?: string;
            shippingState?: string;
            shippingPostalCode?: string;
            shippingPhoneCountryCode?: string;
            shippingPhone?: string;
          }[];
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/contact`,
        method: "GET",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get categories
     *
     * @tags Tags
     * @name CategoryList
     * @request GET:/external-api/category
     */
    categoryList: (params: RequestParams = {}) =>
      this.request<
        { status: "ok"; data: { _id: string; name: string; type: string }[] },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/category`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get tags
     *
     * @tags Tags
     * @name GetExternalApi
     * @request GET:/external-api/tag
     */
    getExternalApi: (params: RequestParams = {}) =>
      this.request<
        {
          status: "ok";
          data: {
            _id: string;
            name: string;
            categoryId: string;
            categoryName: string;
            createdAt: string;
          }[];
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/tag`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create tag
     *
     * @tags Tags
     * @name PostExternalApi
     * @request POST:/external-api/tag
     */
    postExternalApi: (
      body: { categoryId: string; name: string },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          status: "ok";
          data: {
            _id: string;
            name: string;
            categoryId: string;
            categoryName: string;
            createdAt: string;
          };
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/tag`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get tag
     *
     * @tags Tags
     * @name GetExternalApi2
     * @request GET:/external-api/tag/{tagId}
     * @originalName getExternalApi
     * @duplicate
     */
    getExternalApi2: (tagId: string, params: RequestParams = {}) =>
      this.request<
        {
          status: "ok";
          data: {
            _id: string;
            name: string;
            categoryId: string;
            categoryName: string;
            createdAt: string;
          };
        },
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/tag/${tagId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactNoteCreate
     * @request POST:/external-api/contact/note
     */
    contactNoteCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/external-api/contact/note`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name ContactGetByTagQueryCreate
     * @request POST:/external-api/contact/get_by_tag_query
     */
    contactGetByTagQueryCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/external-api/contact/get_by_tag_query`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Add to or remove a tag from the contact
     *
     * @tags Contacts
     * @name ContactTagPartialUpdate
     * @request PATCH:/external-api/contact/tag
     */
    contactTagPartialUpdate: (
      body: { email: string; tagId: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/contact/tag`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Add to or remove a tags from the contact
     *
     * @tags Contacts
     * @name ContactTagsPartialUpdate
     * @request PATCH:/external-api/contact/tags
     */
    contactTagsPartialUpdate: (
      body: { email: string; addTagIds: string[]; removeTagIds: string[] },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/external-api/contact/tags`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  trainingVideo = {
    /**
     * @description Get video
     *
     * @name TrainingVideoDetail
     * @request GET:/training-video/{id}
     */
    trainingVideoDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete video
     *
     * @name TrainingVideoDelete
     * @request DELETE:/training-video/{id}
     */
    trainingVideoDelete: (id: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get all videos
     *
     * @name TrainingVideoList
     * @request GET:/training-video/
     */
    trainingVideoList: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video/`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Create video
     *
     * @name TrainingVideoCreate
     * @request POST:/training-video/
     */
    trainingVideoCreate: (
      body: {
        image: string;
        enabled: boolean;
        name: string;
        categoryId: string;
        createdAt: string;
        description: string;
        vimeoId: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update video
     *
     * @name TrainingVideoUpdate
     * @request PUT:/training-video/
     */
    trainingVideoUpdate: (
      body: {
        _id: string;
        name?: string;
        vimeoId?: string;
        categoryId?: string;
        enabled?: boolean;
        createdAt?: string;
        description?: string;
        image?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video/`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  trainingVideoCategory = {
    /**
     * @description Get video category
     *
     * @name TrainingVideoCategoryDetail
     * @request GET:/training-video-category/{id}
     */
    trainingVideoCategoryDetail: (id: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video-category/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Delete video category
     *
     * @name TrainingVideoCategoryDelete
     * @request DELETE:/training-video-category/{id}
     */
    trainingVideoCategoryDelete: (id: string, params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video-category/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get all videos category
     *
     * @name TrainingVideoCategoryList
     * @request GET:/training-video-category/
     */
    trainingVideoCategoryList: (params: RequestParams = {}) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video-category/`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Create video category
     *
     * @name TrainingVideoCategoryCreate
     * @request POST:/training-video-category/
     */
    trainingVideoCategoryCreate: (
      body: { name: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video-category/`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update video category
     *
     * @name TrainingVideoCategoryUpdate
     * @request PUT:/training-video-category/
     */
    trainingVideoCategoryUpdate: (
      body: { _id: ObjectIdSerialized; name: string },
      params: RequestParams = {}
    ) =>
      this.request<
        any,
        { status: "error"; error: { code: string; message: string } }
      >({
        path: `/training-video-category/`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  groovekart = {
    /**
     * No description
     *
     * @name T30DayWebhookCreate
     * @request POST:/groovekart/t30_day_webhook
     */
    t30DayWebhookCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/groovekart/t30_day_webhook`,
        method: "POST",
        ...params,
      }),
  };
}
